import { map } from "rxjs/operators";
import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { Configuration } from "../models/configuration";
import { ConfigurationService } from "../services/configuration.service";
import { ParameterService } from "../services/parameter.service";
import { Customer } from "../models/customer";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalService } from "../../shared/modal.service";
import { DatePipe, Location } from "@angular/common";
import {
  AbstractControl,
  NgForm,
  NgModel,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Alert, AlertType } from "../../shared/alert.model";
import { MessageService } from "../../shared/message.service";
import { getAlertMessage } from "../../shared/api-loaders";
import { Observable, Subscription } from "rxjs";
import { MessageType } from "../../shared/messageType";
import { ClaimsService } from "../../shared/claims.service";
import { CustomerService } from "../services/customer.service";
import { ConfigurationDeleteConfirmationDialogComponent } from "../configuration-delete-confirmation-dialog/configuration-delete-confirmation-dialog.component";
import { CustomValidators } from "../validators/blank-validator";
import { ParameterValueValidator } from "../validators/parameter-value-validator";
import { Parameter } from "../models/parameter";
import { Select2Option } from "../../shared/select2-option";
import { ParametersDeleteConfirmationDialogComponent } from "../parameters-delete-confirmation-dialog/parameters-delete-confirmation-dialog.component";
import { SecurityService } from "../../shared/security.service";
import { CustomerConfigurationParameters } from "../models/customerConfigurationParameters";
import { ParameterKeys } from "../models/parameterKeys";
import { StackService } from "../services/stack.service";
import { ThirdPartyIntegration } from "../models/ThirdPartyIntegration";
import { ParameterSingleDeleteConfirmationDialogComponent } from "../parameter-single-delete-confirmation-dialog/parameter-single-delete-confirmation-dialog.component";
import { MymatrixConfirmationDialogComponent } from "../mymatrix-confirmation-dialog/mymatrix-confirmation-dialog.component";
import { InformationDialogComponent } from "../information-dialog/information-dialog.component";

@Component({
  selector: "re-configuration-detail",
  templateUrl: "./configuration-detail.component.html",
  styleUrls: ["./configuration-detail.component.scss"],
  standalone: false,
})
export class ConfigurationDetailComponent implements OnInit {
  id: number;
  configuration = new Configuration();
  customer: Customer;
  loading: boolean;
  matrixCare360SeedingLoading: boolean;
  configurationId: number;

  successAlert: Alert;
  alert: Alert;
  showMessage = false;
  hasGlobalError = false;
  editProfile: boolean;
  modalReference: any;
  username: string;
  snfApiKey = "snf.api.url.root";
  mcslApiKey = "sl.api.url.root";
  customerName: string;
  newConfig: boolean;
  editParameters: boolean;
  configCollapse: boolean;
  public parameterId: number;
  public corpOid: any = null;
  public snfAppUrl: any = null;
  enabledDisableData: Select2Option[];
  gsEnabledData: Select2Option[];
  gsEnabled: boolean;
  parameter = new Parameter();
  newParameter: boolean;
  deleteParameterIds: number[] = [];
  isError: boolean;
  snfCorpOidKey = "snf.corpOid";
  snfAppUrlKey = "snf.app.url.root";
  productsNeededCreateParameters: string[] = [];
  batchUpErrorMap: Map<number, boolean> = new Map();
  hasBatchValidationError: boolean;
  somethingIsChecked: boolean;
  newOktaFederationParam: boolean;
  federationParamAtStart: string;
  public federationParamId: number;
  federationObject = [];
  idpIdIsBlank: boolean;
  arrayJsonValue: any[];
  notFederated: boolean;
  signInButtonBlank: boolean;
  logoutUrlHasError: boolean;
  isReadOnlyUser: boolean;
  snfTouched = false;
  lpcTouched = false;
  ppTouched = false;
  rtoTouched = false;
  slTouched = false;
  caTouched = false;
  caOnScreenKeyBoardTouched = false;
  caPinTouched = false;
  mtTouched = false;
  intmTouched = false;
  ccTouched = false;
  ctTouched = false;
  pdTouched = false;
  hhTouched = false;
  bpTouched = false;
  chTouched = false;
  federationTouched = false;
  customerConfigurationParameters: CustomerConfigurationParameters;
  telsUrlParameter = new Parameter();
  vendorOptions: Select2Option[];
  public vendorLoadOptions: ParameterKeys[];
  //vendorOptionsApi: ParameterKeys[];
  vendorOptionsApi: Map<String, any>;
  displayVendorButtons = false;
  newThirdPartyVendor = false;
  commonSharedVendor: boolean;
  uniqueVendor: boolean;
  thirdPartyVendor = new ThirdPartyIntegration();
  stackId: number = 4;
  enableEdit = false;
  enableEditIndex = -1;
  displayNameInitial: string;
  urlInitial: string;
  errorMessage: string;
  addError = false;
  caHotReloading = false;
  deleteLauncherLoading = false;
  globalSearchResetLoading = false;
  globalSearchParameter = null;
  globalSearchEnabled = "false";
  globalSearchEnabledEnding = "false";
  globalSearchTouched = false;
  errorMessageSnfDown: string;
  errorMessageGlobalSearch: string;
  snfApiUrl: string;
  isActive: boolean;
  errorMessageMyMatrix: string;
  errorMessageMatrixCareEForms: string;
  errorMessageMatrixCare360Seeding: string;
  myMatrixTouched = false;
  matrixCareEFormsTouched = false;
  matrixCare360SeedingEnabled: string;
  matrixCare360SeedingTouched = false;
  matrixCare360SeedingParameter = null;
  matrixCare360SeedingEnabledEnding = "false";
  errorMessageSolutionsForBusiness: string;
  solutionsForBusinessTouched = false;
  sbEfaTouched = false;
  sbPnsmTouched = false;
  alineEnabled: string;
  nurseRosieEnabled: string;
  trueSenseEnabled: string;
  alineEnabledEnding = "false";
  alineTouched = false;
  alineParameter = null;
  nurseRosieEnabledEnding = "false";
  nurseRosieTouched = false;
  nurseRosieParameter = null;
  trueSenseEnabledEnding = "false";
  trueSenseTouched = false;
  trueSenseParameter = null;
  sureCountEnabled: string;
  sureCountEnabledEnding = "false";
  sureCountTouched = false;
  sureCountParameter = null;
  myMatrixMessage: string;
  contactFamilyChatTouched = false;
  CISSyncLoading = false;
  guidSyncLoading = false;

  @ViewChild("form")
  form: NgForm;

  configurationDetailForm: UntypedFormGroup = this.fb.group({
    id: [""],
    customerId: [""],
    configName: ["", Validators.required],
    createdBy: [""],
    createdDate: [""],
    modifiedBy: [""],
    modifiedDate: [""],
    configType: ["", Validators.required],
    productsNeeded: this.fb.array([]),
    // packageType: [""],
    userManagementOkta: ["", Validators.required],
    userManagementKeycloak: ["", Validators.required],
    userManagementLegacy: ["", Validators.required],
    sharedComponentsLauncher: ["false"],
    sharedComponentsContextSharing: ["false"],
    subdomainName: [""],
    configNotes: [""],
    guid: [""],
  });

  parameterDetailForm: UntypedFormGroup = this.fb.group({
    id: [""],
    configurationId: [""],
    key: ["", CustomValidators.blankValidator],
    value: [
      "",
      null,
      (_) =>
        ParameterValueValidator.validate2(
          this.parameterDetailForm?.controls["value"],
          this.parameterDetailForm?.controls["key"],
          this.corpOid,
          this.snfAppUrl,
          this.configurationService,
          this.customerService,
          null,
          Number(this.configurationDetailForm?.controls["customerId"].value),
          false,
        ),
    ],
  });

  parameterKeysForm: UntypedFormGroup = this.fb.group({
    corpOid: [this.corpOid],
    snfAppUrl: [this.snfAppUrl],
  });

  parametersEditKeysForm: UntypedFormGroup = this.fb.group({
    corpOid: [this.corpOid],
    snfAppUrl: [this.snfAppUrl],
  });

  federationDetailForm: UntypedFormGroup = this.fb.group({
    id: [""],
    configurationId: [""],
    key: ["", CustomValidators.blankValidator],
    value: this.formBuilder.array([]),
  });

  editFederationForm: UntypedFormGroup = this.fb.group({
    signInButtonText: ["", CustomValidators.blankValidator],
    idpId: ["", CustomValidators.blankValidator],
    logoutUrl: ["", this.urlValidator],
  });

  telsUrlForm: UntypedFormGroup = this.fb.group({
    id: [""],
    configurationId: [""],
    key: ["thirdparty.tels.app.url.root"],
    value: [
      "",
      null,
      (_) =>
        ParameterValueValidator.validate2(
          this.telsUrlForm?.controls["value"],
          this.telsUrlForm?.controls["key"],
          null,
          null,
          this.configurationService,
          this.customerService,
          null,
          null,
          false,
        ),
    ],
  });

  thirdPartyIntegrationForm: UntypedFormGroup = this.fb.group({
    vendorOption: ["", Validators.required],
    vendorType: ["", Validators.required],
    integrationName: [""],
    iconName: ["", CustomValidators.blankValidator],
    key: ["app.url"],
    url: [
      "",
      null,
      (_) =>
        ParameterValueValidator.validate2(
          this.thirdPartyIntegrationForm?.controls["url"],
          this.thirdPartyIntegrationForm?.controls["key"],
          null,
          "",
          this.configurationService,
          this.customerService,
          null,
          null,
          true,
        ),
    ],
  });

  messageSubscription: Subscription;
  confirmationWindowRef: NgbModalRef;
  configurationTypeOptions: string[] = ["", "Production", "Training", "Other"];
  selectedConfigType = "";
  productsOptions = [
    "Skilled Nursing",
    "Senior Living",
    "CareAssist",
    "OnScreenKeyboard",
    "Pin",
    "Meal Tracker",
    "Matrixcare Marketing",
    "Care Community",
    "Matrixcare Connect",
    "Home Care Private Duty",
    "Home Health and Hospice (HHP)",
    "Platform Configurations",
    "Life Plan Community",
    "Citus Health (CH)",
    "Payment Portal",
    "MatrixCare Engage",
    "Contact/Family access to the Chat",
    "MatrixCare eForms",
    "Solutions for Business",
    "Entrance Fee Amortization",
    "Parking & Storage Management",
    "Retail Tracker Online",
  ];
  subdomainName = "";
  configNotes = "";
  newFederationTypeOptions: string[] = [
    "Not Federated (default)",
    "Duo",
    "Microsoft",
    "Okta",
    "One Login",
    "Generic (shows lock icon)",
    "Generic (no icon)",
  ];
  isCaSelected: boolean;
  thirdPartyVendorOptions: string[];

  constructor(
    private route: ActivatedRoute,
    private configurationService: ConfigurationService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private fb: UntypedFormBuilder,
    private modalServiceDeleteConfig: NgbModal,
    private modalServiceDeleteSingleParameter: NgbModal,
    private modalService: ModalService,
    private modalService2: ModalService,
    private parameterService: ParameterService,
    private messageService: MessageService,
    private claimsService: ClaimsService,
    private router: Router,
    private datepipe: DatePipe,
    private customerService: CustomerService,
    private formBuilder: UntypedFormBuilder,
    private securityService: SecurityService,
    private stackService: StackService,
  ) {
    this.messageSubscription = this.messageService
      .get()
      .subscribe((message) => {
        if (message.type == MessageType.ConfigurationCreated) {
          this.alert = {
            type: AlertType.SUCCESS,
            message: `Configuration ${message.data} has been created successfully`,
          };
        }
        if (message.type == MessageType.ParameterCreated) {
          this.alert = {
            type: AlertType.SUCCESS,
            message: `Parameter ${message.data} has been created successfully`,
          };
        }
        this.clearAlerts();
      });

    this.configurationId = +this.route.snapshot.paramMap.get("id");
    if (!this.configurationId) {
      this.newConfig = true;
      this.configuration.userManagementKeycloak = "false";
      this.configuration.userManagementOkta = "false";
      this.newOktaFederationParam = true;
      this.editProfileClicked();
    }
  }

  createFederationItem(): UntypedFormGroup {
    return this.formBuilder.group({
      federationName: "",
      idpId: "",
      signInButtonText: "",
      className: "",
      logoutUrl: "",
      sloEnabled: false,
    });
  }

  addFederationItem(): void {
    var value = this.federationDetailForm.get("value") as UntypedFormArray;
    value.push(this.createFederationItem());
    this.federationDetailForm.get("value")["controls"][0]["controls"][
      "federationName"
    ].value = "Not Federated (default)";
  }

  ngOnDestroy(): void {
    //delete window["currentComponent"];
    this.messageSubscription.unsubscribe();

    //this.dataTable.destroy();
  }

  async ngOnInit() {
    this.parameterDetailForm.controls["key"].valueChanges.subscribe((x) => {
      this.parameterDetailForm.controls["value"].updateValueAndValidity();
    });
    this.isReadOnlyUser = await this.securityService.isThisReadOnlyUser();
    $(function () {
      $('[data-toggle="tooltip"]')["tooltip"]();
    });
    let products = this.configurationDetailForm.controls[
      "productsNeeded"
    ] as UntypedFormArray;
    for (let item of this.productsOptions) {
      products.push(this.fb.control(null));
    }

    /*window["currentComponent"] = this;
    this.populateDataTable();*/
    await this.loadOptions();
    //await this.loadVendorOptions();
    this.username = this.claimsService.getPreferredName();
    this.getCustomerConfigurationParameters();
  }

  public groupedParameters: any;
  public groupedParametersOld: any;

  public getProductKeys(): Array<string> {
    if (!this.groupedParameters) return [];

    return Object.keys(this.groupedParameters).sort((a, b) =>
      a.localeCompare(b),
    );
  }

  public isProductCollapsed: { [key: string]: boolean } = {};

  expandAll() {
    var keys = this.getProductKeys();
    keys.forEach((x) => (this.isProductCollapsed[x] = false));
  }

  collapseAll() {
    var keys = this.getProductKeys();
    keys.forEach((x) => (this.isProductCollapsed[x] = true));
  }

  deleteConfiguration() {
    this.showDeleteConfirmationWindow();
  }

  async showDeleteConfirmationWindow() {
    this.confirmationWindowRef = this.modalServiceDeleteConfig.open(
      ConfigurationDeleteConfirmationDialogComponent,
    );
    const comp = <ConfigurationDeleteConfirmationDialogComponent>(
      this.confirmationWindowRef.componentInstance
    );
    const result: any = await this.confirmationWindowRef.result;
    //return result;

    if (result) {
      const id = +this.configurationDetailForm.get("id").value;
      this.configurationService.deleteConfiguration(id).subscribe(
        (res) => {
          this.goBack();
        },
        (error) => {
          this.alert = getAlertMessage(error);
        },
      );
    }
  }

  async showBulkParameterDeleteConfirmationWindow(deleteCount) {
    this.loading = true;

    var modal =
      this.modalService.create<ParametersDeleteConfirmationDialogComponent>(
        ParametersDeleteConfirmationDialogComponent,
      );

    let deleteCount2: { deleteCount: number } = {
      deleteCount: deleteCount,
    };
    modal.component.deleteCount = deleteCount2;

    var result = await modal.modalRef.result;

    if (result) {
      this.parameterService
        .deleteBatchParameter(this.deleteParameterIds.toString())
        .subscribe(
          (res) => {
            this.resetParameterFlags();
          },
          (error) => {
            this.alert = getAlertMessage(error);
          },
        );
    } else {
      this.loading = false;
    }
  }

  async deleteFederationParameter() {
    const id = +this.federationDetailForm.get("id").value;
    try {
      await this.parameterService.deleteParameter(id).toPromise();
      //// if(this.telsUrlParameter){
      ///  await this.deleteTelsUrlParameter();
      //}
    } catch (e) {
      this.alert = getAlertMessage(e);
    }
  }

  async deleteTelsUrlParameter() {
    const id = this.telsUrlForm.value.id;
    if (typeof id === "number" && id > 0) {
      try {
        await this.parameterService.deleteParameter(id).toPromise();
        this.telsUrlParameter = new Parameter();
        this.telsUrlForm.reset();
        this.telsUrlForm.patchValue({
          id: "",
          configuration: this.configurationId,
          key: "thirdparty.tels.app.url.root",
          value: "",
        });
      } catch (e) {
        this.alert = getAlertMessage(e);
      }
    }
  }

  private productNames = {};

  async refreshForm(configuration) {
    this.isError = false;
    let productsNeededBoolean = [];
    //make sure you handle undefined into empty string TODO kpatel
    if (configuration.productsNeeded) {
      var checkedProducts = configuration.productsNeeded;
      for (let item of this.productsOptions) {
        if (!checkedProducts.firstOrDefault((x) => x == item)) {
          productsNeededBoolean.push(false);
        } else {
          productsNeededBoolean.push(true);
        }
      }
    }

    /*    if (this.configuration.packageType == null) {
      this.configuration.packageType = 'Other';
    }*/

    var products = await this.parameterService.getProductNames().toPromise();
    products.forEach((x) => {
      this.productNames[x.key] = x.name;
    });

    // Normalize user management flags coming from the API. Some endpoints (e.g. customer-onboard)
    // may omit "false" values, which would leave the form controls undefined and therefore invalid
    // for Validators.required. Treat any truthy / "true" value as "true" and default the rest to "false".
    const userManagementOkta =
      configuration.userManagementOkta === true ||
      configuration.userManagementOkta === "true"
        ? "true"
        : "false";

    const userManagementKeycloak =
      configuration.userManagementKeycloak === true ||
      configuration.userManagementKeycloak === "true"
        ? "true"
        : "false";

    const userManagementLegacy =
      configuration.userManagementLegacy === true ||
      configuration.userManagementLegacy === "true"
        ? "true"
        : "false";

    this.configurationDetailForm.patchValue({
      id: configuration.id,
      customerId: configuration.customerId,
      configName: configuration.configName,
      guid: configuration.guid,
      createdBy: configuration.createdBy,
      createdDate: this.datepipe.transform(configuration.createdDate, "medium"),
      modifiedBy: configuration.modifiedBy,
      modifiedDate: this.datepipe.transform(
        configuration.modifiedDate,
        "medium",
      ),
      configType: configuration.configType,
      productsNeeded: productsNeededBoolean || [""],
      // packageType: configuration.packageType,
      userManagementOkta: userManagementOkta,
      userManagementKeycloak: userManagementKeycloak,
      userManagementLegacy: userManagementLegacy,
      sharedComponentsLauncher:
        configuration.sharedComponentsLauncher || "false",
      sharedComponentsContextSharing:
        configuration.sharedComponentsContextSharing || "false",
      subdomainName: configuration.subdomainName || "",
      configNotes: configuration.configNotes || "",
    });
    // Keep backing configuration model in sync so radio button checked states reflect
    // the normalized values as well.
    this.configuration.userManagementOkta = userManagementOkta;
    this.configuration.userManagementKeycloak = userManagementKeycloak;
    this.configuration.userManagementLegacy = userManagementLegacy;
    this.selectedConfigType = configuration.configType;
    this.groupedParameters = this.groupByProductName(
      this.customerConfigurationParameters.parameters.filter(
        (x) => x.configurationId === this.configurationId,
      ),
    );
    this.callHealthchecks();

    this.configuration = configuration;
  }

  async refreshFederationForm(fedParamId, arrayJson) {
    this.federationDetailForm.patchValue({
      id: fedParamId,
      configuration: this.configurationId,
      key: "provision.usermanagement.okta.federation",
      value: arrayJson,
    });
  }

  callHealthchecks() {
    this.errorMessageSnfDown = "";
    Object.keys(this.groupedParameters).forEach((groupName) => {
      this.groupedParameters[groupName].forEach(async (parameter) => {
        // Call Health Check to Check SNF/SL Api
        if (
          (parameter["key"] === this.snfApiKey ||
            parameter["key"] === this.mcslApiKey) &&
          parameter.hasOwnProperty("value") &&
          parameter["value"] !== ""
        ) {
          parameter["status"] = "LOADING";
          await this.parameterService
            .getApiHealthchecks(parameter["key"], parameter["value"])
            .subscribe((result) => {
              parameter["status"] = result["status"];
              if (parameter["status"] === "DOWN") {
                parameter["errorMessage"] = "API service is unavailable.";
                if (
                  parameter["key"] === this.snfApiKey &&
                  parameter["status"] === "DOWN"
                ) {
                  this.errorMessageSnfDown = "API service is unavailable.";
                }
              }
            });
        }
        if (
          parameter["key"] === this.snfAppUrlKey &&
          parameter.hasOwnProperty("value") &&
          parameter["value"] !== ""
        ) {
          this.snfAppUrl = parameter.value;
        }
        if (
          (parameter["key"] == this.snfCorpOidKey ||
            parameter["key"] == this.snfCorpOidKey.toLowerCase()) &&
          parameter.hasOwnProperty("value") &&
          parameter["value"] !== ""
        ) {
          this.corpOid = parameter.value;
        }
      });
    });
  }

  getNgStyleColorBasedOnStatus(status) {
    if (status === "LOADING") {
      return "#141888";
    } else if (status === "UP") {
      return "#26882B";
    } else if (status === "DOWN") {
      return "#ff0000";
    } else {
      return "#1e2aff";
    }
  }

  groupByProductName(parameters: any[]): any {
    const groups = {};

    for (const x of parameters) {
      const productName = x.key.split(".")[0];
      const gsEnabled = x.key.split(".")[1] + x.key.split(".")[2];
      if (
        productName === "provision" ||
        productName === "thirdparty" ||
        productName === "thirdpartyintegration" ||
        gsEnabled === "globalsearchenabled" ||
        productName === "multicare" ||
        productName === "ssointegrations" ||
        productName === "paymentportal" ||
        productName === "rt" ||
        productName === "sb"
      ) {
        continue;
      }
      const displayName = this.getProductDisplayName(productName);
      groups[displayName] = groups[displayName] || [];
      groups[displayName].push({ ...x, status: "", errorMessage: "" });
    }

    return groups;
  }

  groupByThirdPartyPrefix(parameters: any[]): Map<String, any> {
    const groups = new Map<String, any>();

    for (const x of parameters) {
      const keyPart = x.key.split(".");
      const productName = keyPart[0];
      if (productName !== "thirdpartyintegration") {
        continue;
      }
      const integrationName = keyPart[1];
      const prefix = productName + "." + integrationName;
      var values = groups.get(prefix);

      if (!values) {
        values = {};
        groups.set(prefix, values);
      }

      if (keyPart[2] === "displayname") {
        values.integrationprefix = prefix;
        values.displaynameid = x.id;
        values.displaynamevalue = x.value;
      } else if (keyPart[2] === "url") {
        values.integrationprefix = prefix;
        values.urlid = x.id;
        values.urlvalue = x.value;
      }
    }

    return groups;
  }

  getProductDisplayName(productName: any): any {
    if (this.productNames[productName]) return this.productNames[productName];

    return productName;
  }

  goBack(): void {
    this.location.back();
  }

  clearAlerts() {
    this.hasGlobalError = false;
    setTimeout(() => {
      this.alert = null;
      this.showMessage = false;
    }, 5000);
  }

  editProfileClicked() {
    this.editProfile = true;
    this.editParameters = false;
    this.configCollapse = false;
    this.thirdPartyVendor.vendorOption = null;
  }

  editParametersClicked() {
    this.editParameters = true;
    this.editProfile = false;
    this.parameterService
      .getParametersByConfigId(this.configurationId)
      .subscribe((data) => {
        this.groupedParametersOld = this.groupByProductName(
          data.filter((x) => x.configurationId === this.configurationId),
        );
      });

    this.parametersEditKeysForm.patchValue({
      corpOid: this.corpOid,
      snfAppUrl: this.snfAppUrl,
    });
  }

  async resetFlags() {
    this.loading = true;
    if (!this.configurationId) {
      this.goBack();
      return;
    }
    this.editProfile = false;
    this.configurationDetailForm.reset();
    this.snfTouched = false;
    this.lpcTouched = false;
    this.ppTouched = false;
    this.rtoTouched = false;
    this.slTouched = false;
    this.caTouched = false;
    this.caOnScreenKeyBoardTouched = false;
    this.caPinTouched = false;
    this.mtTouched = false;
    this.intmTouched = false;
    this.ccTouched = false;
    this.ctTouched = false;
    this.pdTouched = false;
    this.hhTouched = false;
    this.bpTouched = false;
    this.chTouched = false;
    this.federationTouched = false;
    this.telsUrlForm.reset();
    this.telsUrlForm.patchValue({
      id: "",
      configuration: this.configurationId,
      key: "thirdparty.tels.app.url.root",
      value: "",
    });
    this.errorMessageGlobalSearch = "";
    this.errorMessageMyMatrix = "";
    this.errorMessageMatrixCareEForms = "";
    this.errorMessageMatrixCare360Seeding = "";
    this.errorMessageSolutionsForBusiness = "";
    this.myMatrixMessage = "";
    this.globalSearchTouched = false;
    this.myMatrixTouched = false;
    this.contactFamilyChatTouched = false;
    this.matrixCareEFormsTouched = false;
    this.matrixCare360SeedingTouched = false;
    this.sbEfaTouched = false;
    this.sbPnsmTouched = false;
    this.solutionsForBusinessTouched = false;
    this.alineTouched = false;
    this.nurseRosieTouched = false;
    this.matrixCare360SeedingEnabledEnding =
      this.matrixCare360SeedingEnabled || "false";
    await this.getCustomerConfigurationParameters();
    this.loading = false;
  }

  resetParameterFlags() {
    this.editParameters = false;
    this.loading = false;
    this.refreshParameterListForm();
  }

  async cancelParameters() {
    await this.refreshParameterListForm();
    this.editParameters = false;
    $("#cb_slselectall").prop("checked", false);
    this.uncheckAllCheckBox();
    this.loading = false;
  }

  /*  async getConfiguration() {
      if (!this.configurationId)
        return;

      const id = +this.route.snapshot.paramMap.get('id');

      let configuration = await this.configurationService.getConfiguration(id).toPromise();
      //get federation parameter
      let oktaFederationParameter = await this.parameterService.getParameterByKey(String(this.configurationId),"provision.usermanagement.okta.federation").toPromise();
      this.federationDetailForm.get('configurationId').setValue(this.configurationId);
      //need this to created the three checkboxes for federated login is user management is okta
      if(configuration.userManagementOkta){
        this.userManagementChanged('Okta');
      }
      this.isCaSelected=false;
      if(configuration.productsNeeded.toString().includes('CareAssist')){
        this.isCaSelected=true;
      }

      //if an okta federation parameter gets returned, then it is not a new parameter.
      if(oktaFederationParameter.length>0){
        this.newOktaFederationParam = false;
        this.federationParamId = oktaFederationParameter[0].id;
        this.arrayJsonValue=JSON.parse(oktaFederationParameter[0].value);

        this.federationDetailForm.patchValue({
          id: this.federationParamId,
          configuration: this.configurationId,
          key: 'provision.usermanagement.okta.federation',
          value: this.arrayJsonValue
        });

        if(this.federationDetailForm.get('value')['controls'][0]['controls']['federationName'].value.toLowerCase().includes("not federated")){
          this.notFederated = true;
        } else{this.notFederated = false};

      } else if (oktaFederationParameter.length == 0 && configuration.userManagementOkta){
        this.newOktaFederationParam = true;
        this.federationDetailForm.get('value')['controls'][0]['controls']['federationName'].value = "Not Federated (default)";
        this.notFederated = true;
      }
        await this.refreshForm(configuration);
    }*/

  public async setUpFedParameter(configId) {
    //this block only adds to the object the values that are checked to save to the database.
    this.federationObject = [];
    this.federationObject.push(this.federationDetailForm.get("value").value[0]);

    //if federation object is greater than 0, go update it
    if (
      this.configuration.userManagementOkta == "true" &&
      this.federationObject.length > 0 &&
      !this.notFederated
    ) {
      await this.addUpdateFederationParameter(configId);
    }
    //delete the parameter if length is 0 because that means we unchecked it or if its not Okta (if we went from okta to keycloak then we have to remove federation param)
    if (
      (!this.newOktaFederationParam &&
        this.configuration.userManagementOkta == "false") ||
      (!this.newOktaFederationParam && this.notFederated)
    ) {
      await this.deleteFederationParameter();
    }
  }

  // TODO: Make use of the functions available in config-list component with component to component interaction to avoid code duplication
  updateConfiguration(): void {
    // Validate Solutions for Business modules before submission
    this.validateSolutionsForBusinessModules();
    if (this.errorMessageSolutionsForBusiness) {
      return;
    }

    if (
      this.configurationDetailForm.dirty ||
      this.federationTouched ||
      this.telsUrlForm.dirty ||
      this.globalSearchTouched ||
      this.myMatrixTouched ||
      this.matrixCareEFormsTouched ||
      this.alineTouched ||
      this.nurseRosieTouched ||
      this.trueSenseTouched ||
      this.sureCountTouched ||
      this.solutionsForBusinessTouched
    ) {
      this.loading = true;
      this.updateProvisionMultiSelectValues();
      const config = new Configuration(this.configurationDetailForm.value);
      config.isGlobal = false;
      let obs: Observable<Configuration>;
      if (this.configurationId) {
        delete config.modifiedBy;
        delete config.modifiedDate;

        config.modifiedBy = this.username;
        obs = this.configurationService.updateConfiguration(
          this.configurationId,
          config,
        );
      }
      obs.subscribe(
        async (configuration) => {
          // If customer was updated successfully, id must have some value.
          await this.addDefaultParameters(this.configurationId);
          if (this.federationTouched) {
            await this.setUpFedParameter(this.configurationId);
          }
          if (
            this.globalSearchTouched ||
            this.matrixCare360SeedingTouched ||
            this.matrixCareEFormsTouched ||
            this.alineTouched ||
            this.nurseRosieTouched ||
            this.trueSenseTouched ||
            this.sureCountTouched
          ) {
            await this.addUpdateDeleteBatchParametersEnabled(
              this.configurationId,
            );
          }
          await this.addTelsUrl(this.configurationId);
          if (this.configurationId) {
            this.successAlert = {
              message: `Configuration ${config.configName} has been updated successfully`,
              type: AlertType.SUCCESS,
            };
            this.resetFlags();
          }
        },
        (err) => {
          this.alert = getAlertMessage(err);
        },
      );
    }
    this.editProfile = false;
  }

  addConfiguration(): void {
    this.loading = true;
    this.updateProvisionMultiSelectValues();
    const config = new Configuration(this.configurationDetailForm.value);
    config.isGlobal = false;
    let obs: Observable<Configuration>;
    config.createdBy = this.username;
    config.customerId = +this.route.snapshot.paramMap.get("customerId");
    obs = this.configurationService.addConfiguration(config);

    obs.subscribe(
      async (configuration) => {
        // If customer was updated successfully, id must have some value.
        await this.addDefaultParameters(configuration.id);
        await this.setUpFedParameter(configuration.id);
        await this.addTelsUrl(configuration.id);
        if (
          this.globalSearchTouched ||
          this.matrixCare360SeedingTouched ||
          this.matrixCareEFormsTouched ||
          this.alineTouched ||
          this.nurseRosieTouched ||
          this.trueSenseTouched ||
          this.sureCountTouched
        ) {
          await this.addUpdateDeleteBatchParametersEnabled(configuration.id);
        }
        this.router
          .navigate(["/ect/configurations/detail", configuration.id], {
            replaceUrl: true,
          })
          .then((status) => {
            this.newConfig = true;
            this.newOktaFederationParam = true;
            if (status) {
              this.messageService.send({
                type: MessageType.ConfigurationCreated,
                data: config.configName,
              });
            }
          });
      },
      (err) => {
        this.alert = getAlertMessage(err);
      },
    );
  }

  updateProvisionMultiSelectValues(): void {
    //products needed for client block
    let productsNeededString = [];
    var checkedProducts =
      this.configurationDetailForm.controls["productsNeeded"].value;
    for (let i = 0; i < this.productsOptions.length; i++) {
      if (!checkedProducts[i]) {
        productsNeededString.push("");
      } else {
        productsNeededString.push(this.productsOptions[i]);
      }
    }
    this.configurationDetailForm
      .get("productsNeeded")
      .setValue(productsNeededString);

    //User Management block
    this.configurationDetailForm
      .get("userManagementOkta")
      .setValue(
        this.configurationDetailForm.controls["userManagementOkta"].value,
      );
    this.configurationDetailForm
      .get("userManagementKeycloak")
      .setValue(
        this.configurationDetailForm.controls["userManagementKeycloak"].value,
      );
    this.configurationDetailForm
      .get("userManagementLegacy")
      .setValue(
        this.configurationDetailForm.controls["userManagementLegacy"].value,
      );

    //shared component block
    this.configurationDetailForm
      .get("sharedComponentsLauncher")
      .setValue(
        this.configurationDetailForm.controls["sharedComponentsLauncher"].value,
      );
    this.configurationDetailForm
      .get("sharedComponentsContextSharing")
      .setValue(
        this.configurationDetailForm.controls["sharedComponentsContextSharing"]
          .value,
      );

    /*    if (this.configurationDetailForm.get("packageType").value == '') {
      (this.configurationDetailForm.get("packageType").setValue('Other'));
    }*/
  }

  public async addDefaultParameters(configId) {
    this.loading = true;
    this.deleteParameterIds = [];
    let addSnfParameters = false;
    let addLpcParameters = false;
    let addPpParameters = false;
    let addSlParameters = false;
    let addCaParameters = false;
    let addCaOnScreenKeyBoardParameters = false;
    let addCaPinParameters = false;
    let addMtParameters = false;
    let addIntmParameters = false;
    let addCcParameters = false;
    let addCtParameters = false;
    let addPdParameters = false;
    let addHhParameters = false;
    let addBpParameters = false;
    let addChParameters = false;
    let addMatrixCareEngageParameters = false;
    let addContactFamilyChatParameters = false;
    let addMatrixCareEFormsParameters = false;
    let addSolutionsForBusinessParameters = false;
    let addSbEfaParameters = false;
    let addSbPnsmParameters = false;
    let addRtoParameters = false;
    this.productsNeededCreateParameters =
      this.configurationDetailForm.get("productsNeeded").value;
    //The else is needed because if new config, we dont want it to go to delete else itll error
    //Then we only want it to go to the delete if the product actually exists to delete and not always for performance.
    if (this.productsNeededCreateParameters.includes("Skilled Nursing")) {
      if (this.snfTouched) addSnfParameters = true;
    } else if (!this.newConfig && this.groupedParameters["Skilled Nursing"]) {
      this.compileDeleteIdsOnUnselectIds("Skilled Nursing");
      this.snfApiUrl = "";
    }
    if (this.productsNeededCreateParameters.includes("Life Plan Community")) {
      if (this.lpcTouched) addLpcParameters = true;
    } else if (
      !this.newConfig &&
      this.groupedParameters["Life Plan Community"]
    ) {
      this.compileDeleteIdsOnUnselectIds("Life Plan Community");
    }

    if (this.productsNeededCreateParameters.includes("Payment Portal")) {
      if (this.ppTouched) addPpParameters = true;
    } else if (
      !this.newConfig &&
      !this.groupedParameters["Payment Portal"] &&
      this.ppTouched
    ) {
      //special case since we hide payment portal from group parameters, so we need to retrieve the id of param and manually add it to delete
      let ppParameter = this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "paymentportal.enabled",
      );
      if (ppParameter.length > 0) {
        this.deleteParameterIds.push(ppParameter[0].id);
      }
    }

    if (this.productsNeededCreateParameters.includes("Retail Tracker Online")) {
      if (this.rtoTouched) addRtoParameters = true;
    } else if (
      !this.newConfig &&
      this.rtoTouched
    ) {
      let rtoParameter = this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "rt.online.enabled",
      );
      if (rtoParameter.length > 0) {
        this.deleteParameterIds.push(rtoParameter[0].id);
      }
    }

    if (this.productsNeededCreateParameters.includes("Senior Living")) {
      if (this.slTouched) addSlParameters = true;
    } else if (!this.newConfig && this.groupedParameters["Senior Living"]) {
      this.compileDeleteIdsOnUnselectIds("Senior Living");
    }

    if (this.productsNeededCreateParameters.includes("CareAssist")) {
      if (this.caTouched) addCaParameters = true;
    } else if (!this.newConfig && this.groupedParameters["CareAssist"]) {
      this.compileDeleteIdsOnUnselectIds("CareAssist");
    }

    if (this.productsNeededCreateParameters.includes("OnScreenKeyboard")) {
      if (this.caOnScreenKeyBoardTouched)
        addCaOnScreenKeyBoardParameters = true;
    } else if (
      !this.newConfig &&
      this.groupedParameters["CareAssist"] &&
      this.isCaSelected
    ) {
      this.compileDeleteIdsOnUnselectIdsCareAssist("OnScreenKeyboard");
    }

    if (this.productsNeededCreateParameters.includes("Pin")) {
      if (this.caPinTouched) addCaPinParameters = true;
    } else if (
      !this.newConfig &&
      this.groupedParameters["CareAssist"] &&
      this.isCaSelected
    ) {
      this.compileDeleteIdsOnUnselectIdsCareAssist("Pin");
    }

    if (this.productsNeededCreateParameters.includes("Meal Tracker")) {
      if (this.mtTouched) addMtParameters = true;
    } else if (!this.newConfig && this.groupedParameters["Meal Tracker"]) {
      this.compileDeleteIdsOnUnselectIds("Meal Tracker");
    }

    if (this.productsNeededCreateParameters.includes("Matrixcare Marketing")) {
      if (this.intmTouched) addIntmParameters = true;
    } else if (
      !this.newConfig &&
      this.groupedParameters["Matrixcare Marketing"]
    ) {
      this.compileDeleteIdsOnUnselectIds("Matrixcare Marketing");
    }

    if (this.productsNeededCreateParameters.includes("Care Community")) {
      if (this.ccTouched) addCcParameters = true;
    } else if (!this.newConfig && this.groupedParameters["Care Community"]) {
      this.compileDeleteIdsOnUnselectIds("Care Community");
    }

    if (this.productsNeededCreateParameters.includes("Matrixcare Connect")) {
      if (this.ctTouched) addCtParameters = true;
    } else if (
      !this.newConfig &&
      this.groupedParameters["Matrixcare Connect"]
    ) {
      this.compileDeleteIdsOnUnselectIds("Matrixcare Connect");
    }

    if (
      this.productsNeededCreateParameters.includes("Home Care Private Duty")
    ) {
      if (this.pdTouched) addPdParameters = true;
    } else if (
      !this.newConfig &&
      this.groupedParameters["Home Care Private Duty"]
    ) {
      this.compileDeleteIdsOnUnselectIds("Home Care Private Duty");
    }

    if (
      this.productsNeededCreateParameters.includes(
        "Home Health and Hospice (HHP)",
      )
    ) {
      if (this.hhTouched) addHhParameters = true;
    } else if (
      !this.newConfig &&
      this.groupedParameters["Home Health and Hospice (HHP)"]
    ) {
      this.compileDeleteIdsOnUnselectIds("Home Health and Hospice (HHP)");
    }

    if (
      this.productsNeededCreateParameters.includes("Platform Configurations")
    ) {
      if (this.bpTouched) addBpParameters = true;
    } else if (
      !this.newConfig &&
      this.groupedParameters["Platform Configurations"]
    ) {
      this.compileDeleteIdsOnUnselectIds("Platform Configurations");
    }

    if (this.productsNeededCreateParameters.includes("Citus Health (CH)")) {
      if (this.chTouched) addChParameters = true;
    } else if (!this.newConfig && this.groupedParameters["Citus Health (CH)"]) {
      this.compileDeleteIdsOnUnselectIds("Citus Health (CH)");
    }

    if (this.productsNeededCreateParameters.includes("MatrixCare Engage")) {
      if (this.myMatrixTouched) addMatrixCareEngageParameters = true;
    } else if (!this.newConfig && this.myMatrixTouched) {
      let matrixEngageParameter =
        this.customerConfigurationParameters.parameters.filter(
          (x) => x.key === "multicare.mobile.enabled",
        );
      if (matrixEngageParameter.length > 0) {
        this.deleteParameterIds.push(matrixEngageParameter[0].id);
      }
    }

    if (
      this.productsNeededCreateParameters.includes(
        "Contact/Family access to the Chat",
      )
    ) {
      if (this.contactFamilyChatTouched) addContactFamilyChatParameters = true;
    } else if (!this.newConfig && this.contactFamilyChatTouched) {
      let contactFamilyChatParameter =
        this.customerConfigurationParameters.parameters.filter(
          (x) => x.key === "multicare.mobile.familychat.enabled",
        );
      if (contactFamilyChatParameter.length > 0) {
        this.deleteParameterIds.push(contactFamilyChatParameter[0].id);
      }
    }

    if (this.productsNeededCreateParameters.includes("MatrixCare eForms")) {
      if (this.matrixCareEFormsTouched) addMatrixCareEFormsParameters = true;
    } else if (!this.newConfig && this.matrixCareEFormsTouched) {
      let matrixEFormsParameter =
        this.customerConfigurationParameters.parameters.filter(
          (x) => x.key === "multicare.eforms.enabled",
        );
      if (matrixEFormsParameter.length > 0) {
        this.deleteParameterIds.push(matrixEFormsParameter[0].id);
      }
    }

    if (
      this.productsNeededCreateParameters.includes("Solutions for Business")
    ) {
      if (this.solutionsForBusinessTouched)
        addSolutionsForBusinessParameters = true;
    } else if (!this.newConfig && this.solutionsForBusinessTouched) {
      let solutionsForBusinessParameter =
        this.customerConfigurationParameters.parameters.filter(
          (x) => x.key === "sb.module.enabled",
        );
      if (solutionsForBusinessParameter.length > 0) {
        this.deleteParameterIds.push(solutionsForBusinessParameter[0].id);
      }
    }

    if (
      this.productsNeededCreateParameters.includes("Entrance Fee Amortization")
    ) {
      if (this.sbEfaTouched) addSbEfaParameters = true;
    } else if (!this.newConfig && this.sbEfaTouched) {
      let efaParameter = this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "sb.module.efa.enabled",
      );
      if (efaParameter.length > 0) {
        this.deleteParameterIds.push(efaParameter[0].id);
      }
    }

    if (
      this.productsNeededCreateParameters.includes(
        "Parking & Storage Management",
      )
    ) {
      if (this.sbPnsmTouched) addSbPnsmParameters = true;
    } else if (!this.newConfig && this.sbPnsmTouched) {
      let pnsmParameter =
        this.customerConfigurationParameters.parameters.filter(
          (x) => x.key === "sb.module.pnsm.enabled",
        );
      if (pnsmParameter.length > 0) {
        this.deleteParameterIds.push(pnsmParameter[0].id);
      }
    }

    if (
      addSnfParameters ||
      addSlParameters ||
      addCaParameters ||
      addCaPinParameters ||
      addCaOnScreenKeyBoardParameters ||
      addMtParameters ||
      addIntmParameters ||
      addCcParameters ||
      addCtParameters ||
      addPdParameters ||
      addHhParameters ||
      addBpParameters ||
      addLpcParameters ||
      addChParameters ||
      addPpParameters ||
      addMatrixCareEngageParameters ||
      addContactFamilyChatParameters ||
      addMatrixCareEFormsParameters ||
      addSolutionsForBusinessParameters ||
      addSbEfaParameters ||
      addSbPnsmParameters ||
      addRtoParameters
    ) {
      try {
        await this.configurationService
          .addDefaultParameters(
            configId,
            addSnfParameters,
            addSlParameters,
            addCaParameters,
            addCaOnScreenKeyBoardParameters,
            addCaPinParameters,
            addMtParameters,
            addIntmParameters,
            addCcParameters,
            addCtParameters,
            addPdParameters,
            addHhParameters,
            addBpParameters,
            addLpcParameters,
            addChParameters,
            addPpParameters,
            addMatrixCareEngageParameters,
            addContactFamilyChatParameters,
            addMatrixCareEFormsParameters,
            addSolutionsForBusinessParameters,
            addSbEfaParameters,
            addSbPnsmParameters,
            addRtoParameters,
            this.configurationDetailForm.get("subdomainName").value,
          )
          .toPromise();
      } catch (err) {
        this.alert = getAlertMessage(err);
      }
    }
    if (this.deleteParameterIds.length > 0) {
      await this.parameterService
        .deleteBatchParameter(this.deleteParameterIds.toString())
        .toPromise();
    }
  }

  public async addTelsUrl(configId) {
    //if federated and tels url touched and has a value, then go into add or update
    if (this.telsUrlForm.dirty && this.telsUrlForm.value.value != "") {
      await this.addUpdateTelsUrl(configId);
    }
    //delete the parameter if either user is federated but removed tels url OR
    //delete if user switched to not federated and tels url had a value
    //why are we again delting the TELS value . Its an or condition so not tied to federated
    if (this.telsUrlForm.dirty && this.telsUrlForm.value.value === "") {
      await this.deleteTelsUrlParameter();
    }
  }

  public async addUpdateFederationParameter(configId) {
    this.loading = true;
    this.newParameter = this.newOktaFederationParam;
    const parameter = new Parameter();
    let obs: Observable<Parameter>;

    //new fed param then add, else update
    if (this.newOktaFederationParam) {
      this.federationDetailForm
        .get("key")
        .setValue("provision.usermanagement.okta.federation");
      parameter.configurationId = configId;
      parameter.createdBy = this.username;
      parameter.key = this.federationDetailForm.get("key").value;
      parameter.value = JSON.stringify(this.federationObject);

      obs = this.parameterService.addParameter(parameter);
      let addFedParameter = await obs.toPromise();
      // If customer was added successfully, id must have some value.
      if (addFedParameter.id) {
        this.loading = false;
        this.refreshFederationForm(
          addFedParameter.id,
          this.federationDetailForm.get("value").value,
        );
        this.successAlert = {
          message: `Parameter: ${addFedParameter.key} has been created successfully`,
          type: AlertType.SUCCESS,
        };
        this.clearAlerts();
      }
    }
    //if not new param and start and end are diff, then update
    else if (
      !this.newOktaFederationParam &&
      !(this.federationParamAtStart == JSON.stringify(this.federationObject))
    ) {
      parameter.id = this.federationParamId;
      parameter.modifiedBy = this.username;
      parameter.configurationId = configId;
      parameter.createdBy = this.username;
      parameter.key = this.federationDetailForm.get("key").value;
      parameter.value = JSON.stringify(this.federationObject);

      obs = this.parameterService.updateParameter(
        this.federationParamId,
        parameter,
      );
      let updateFedParameter = await obs.toPromise();
      // If customer was updated successfully, id must have some value.
      if (this.federationParamId) {
        this.loading = false;
        this.refreshFederationForm(
          this.federationParamId,
          this.federationDetailForm.get("value").value,
        );
        this.successAlert = {
          message: `Parameter: ${this.federationDetailForm.get("key").value} has been updated successfully`,
          type: AlertType.SUCCESS,
        };
        this.clearAlerts();
      }
    }
    this.loading = false;
  }

  public async addUpdateTelsUrl(configId) {
    const parameter = new Parameter();
    let obs: Observable<Parameter>;

    //if new tels parameter add tels param
    if (!this.telsUrlForm.value.id) {
      parameter.configurationId = configId;
      parameter.createdBy = this.username;
      parameter.key = "thirdparty.tels.app.url.root";
      parameter.value = this.telsUrlForm.value.value.trim();

      obs = this.parameterService.addParameter(parameter);
      let addTelsParameter = await obs.toPromise();
      // If customer was added successfully, id must have some value.
      if (addTelsParameter.id) {
        this.telsUrlForm.patchValue({
          id: addTelsParameter.id,
          configuration: this.configurationId,
          key: addTelsParameter.key,
          value: addTelsParameter.value,
        });
        this.successAlert = {
          message: `Parameter: ${addTelsParameter.key} has been created successfully`,
          type: AlertType.SUCCESS,
        };
        this.clearAlerts();
      }
    }
    //if not new param then update tels param
    else if (this.telsUrlForm.value.id) {
      parameter.id = this.telsUrlForm.value.id;
      parameter.modifiedBy = this.username;
      parameter.configurationId = configId;
      parameter.createdBy = this.username;
      parameter.key = "thirdparty.tels.app.url.root";
      parameter.value = this.telsUrlForm.value.value.trim();

      obs = this.parameterService.updateParameter(
        this.telsUrlForm.value.id,
        parameter,
      );
      let updateTelsParameter = await obs.toPromise();

      // If customer was updated successfully, id must have some value.
      this.telsUrlForm.patchValue({
        id: this.telsUrlForm.value.id,
        configuration: this.configurationId,
        key: this.telsUrlForm.value.key,
        value: this.telsUrlForm.value.value.trim(),
      });
      this.successAlert = {
        message: `Parameter: thirdparty.tels.app.url.root has been updated successfully`,
        type: AlertType.SUCCESS,
      };
      this.clearAlerts();
    }
  }

  compileDeleteIdsOnUnselectIds(product) {
    if (this.groupedParameters[product]) {
      this.groupedParameters[product].forEach((x) => {
        this.deleteParameterIds.push(x.id);
      });
    }
  }

  compileDeleteIdsOnUnselectIdsCareAssist(product) {
    if (product == "OnScreenKeyboard") {
      if (this.groupedParameters["CareAssist"]) {
        this.groupedParameters["CareAssist"].forEach((x) => {
          if (
            x.key
              .toLowerCase()
              .includes("ca.feature.onscreenkeyboard.optiononloginpage")
          ) {
            this.deleteParameterIds.push(x.id);
          }
        });
      }
    }

    if (product == "Pin") {
      if (this.groupedParameters["CareAssist"]) {
        this.groupedParameters["CareAssist"].forEach((x) => {
          if (x.key.toLowerCase().includes("ca.feature.pin.")) {
            this.deleteParameterIds.push(x.id);
          }
        });
      }
    }
  }

  /*  packageTypeChanged(item) {
    this.configurationDetailForm.get("packageType").setValue(item);
  }*/

  userManagementChanged(item) {
    var value = this.federationDetailForm.get("value") as UntypedFormArray;
    value.controls.splice(0, value.controls.length);

    if (item == "Okta") {
      this.configurationDetailForm.get("userManagementOkta").setValue("true");
      this.configuration.userManagementOkta = "true";
      this.configuration.userManagementKeycloak = "false";
      this.configurationDetailForm
        .get("userManagementKeycloak")
        .setValue("false");
      this.configuration.userManagementLegacy = "false";
      this.configurationDetailForm
        .get("userManagementLegacy")
        .setValue("false");

      this.sharedComponentsLauncherChanged("true");
      this.sharedComponentsContextSharingChanged("true");

      this.addFederationItem();
      this.notFederated = true;
    } else if (item == "Keycloak") {
      this.configurationDetailForm
        .get("userManagementKeycloak")
        .setValue("true");
      this.configuration.userManagementKeycloak = "true";
      this.configuration.userManagementOkta = "false";
      this.configurationDetailForm.get("userManagementOkta").setValue("false");
      this.configuration.userManagementLegacy = "false";
      this.configurationDetailForm
        .get("userManagementLegacy")
        .setValue("false");

      this.sharedComponentsLauncherChanged("true");
      this.sharedComponentsContextSharingChanged("true");
      this.matrixCare360SeedingChanged("false");
      this.alineChanged("false");
      this.nurseRosieChanged("false");
      this.trueSenseChanged("false");
      this.sureCountChanged("false");
      this.signInButtonBlank = false;
      this.idpIdIsBlank = false;
      this.logoutUrlHasError = false;
    } else {
      this.configurationDetailForm.get("userManagementLegacy").setValue("true");
      this.configurationDetailForm
        .get("userManagementKeycloak")
        .setValue("false");
      this.configurationDetailForm.get("userManagementOkta").setValue("false");
      this.configuration.userManagementLegacy = "true";
      this.configuration.userManagementOkta = "false";
      this.configuration.userManagementKeycloak = "false";

      this.sharedComponentsLauncherChanged("false");
      this.sharedComponentsContextSharingChanged("false");
      this.globalSearchChanged("false");
      this.matrixCare360SeedingChanged("false");
      this.alineChanged("false");
      this.nurseRosieChanged("false");
      this.trueSenseChanged("false");
      this.sureCountChanged("false");
      this.signInButtonBlank = false;
      this.idpIdIsBlank = false;
      this.logoutUrlHasError = false;
    }
  }

  onFederationChange(i, optionvalue, item) {
    this.federationTouched = true;
    if (optionvalue.toLowerCase().includes("not federated")) {
      this.notFederated = true;
      //clear out values
      item.value.idpId = "";
      item.value.signInButtonText = "";
      item.value.className = "";
      item.value.logoutUrl = "";
      item.value.sloEnabled = false;
      this.signInButtonBlank = false;
      this.idpIdIsBlank = false;
      this.logoutUrlHasError = false;
    } else {
      this.notFederated = false;
      //set federation name
      this.federationDetailForm.get("value")["controls"][i]["controls"][
        "federationName"
      ].value = optionvalue;
      if (optionvalue) {
        this.federationDetailForm.get("value")["controls"][i]["controls"][
          "signInButtonText"
        ].value = "Sign in with " + optionvalue;
        this.federationDetailForm.get("value")["controls"][i]["controls"][
          "idpId"
        ].value = "";
        this.federationDetailForm.get("value")["controls"][i]["controls"][
          "logoutUrl"
        ].value = "";
        this.federationDetailForm.get("value")["controls"][i]["controls"][
          "sloEnabled"
        ].value = false;
        item.value.signInButtonText =
          this.federationDetailForm.get("value")["controls"][i]["controls"][
            "signInButtonText"
          ].value;
        this.onButtonChange(item);
        item.value.idpId = "";
        item.value.logoutUrl = "";
        item.value.sloEnabled = false;
        switch (optionvalue) {
          case "One Login": {
            item.value.className = `social-auth-one-button`;
            item.value.signInButtonText = "Sign in with One Login";
            this.federationDetailForm.get("value")["controls"][i]["controls"][
              "className"
            ].value = `social-auth-one-button`;
            this.federationDetailForm.get("value")["controls"][i]["controls"][
              "signInButtonText"
            ].value = "Sign in with One Login";
            break;
          }
          case "Generic (shows lock icon)": {
            item.value.className = `social-auth-generic-button`;
            item.value.signInButtonText = "Sign in with organizational account";
            this.federationDetailForm.get("value")["controls"][i]["controls"][
              "className"
            ].value = `social-auth-generic-button`;
            this.federationDetailForm.get("value")["controls"][i]["controls"][
              "signInButtonText"
            ].value = "Sign in with organizational account";
            break;
          }
          case "Generic (no icon)": {
            item.value.className = `social-auth-button`;
            item.value.signInButtonText = "Sign in with organizational account";
            this.federationDetailForm.get("value")["controls"][i]["controls"][
              "className"
            ].value = `social-auth-button`;
            this.federationDetailForm.get("value")["controls"][i]["controls"][
              "signInButtonText"
            ].value = "Sign in with organizational account";
            break;
          }
          default: {
            item.value.className =
              "social-auth-" + optionvalue.toLowerCase() + "-button";
            this.federationDetailForm.get("value")["controls"][i]["controls"][
              "className"
            ].value = "social-auth-" + optionvalue.toLowerCase() + "-button";
            break;
          }
        }
      }
    }

    if (
      !this.federationDetailForm
        .get("value")
        .value[0].federationName.toLowerCase()
        .includes("not federated") &&
      this.federationDetailForm.get("value").value[0].idpId == ""
    ) {
      this.idpIdIsBlank = true;
    } else {
      this.idpIdIsBlank = false;
    }
  }

  onIdpIdChange(item) {
    this.federationTouched = true;
    item.value.idpId = item.value.idpId.trim();
    this.editFederationForm.patchValue({
      idpId: item.value.idpId,
    });
    if (this.editFederationForm.controls["idpId"].hasError("blank")) {
      item["idpIdError"] = "Please enter the Identity Provider ID.";
      this.idpIdIsBlank = true;
    } else {
      item["idpIdError"] = "";
      this.idpIdIsBlank = false;
    }
  }

  onButtonChange(item) {
    this.federationTouched = true;
    item.value.signInButtonText = item.value.signInButtonText.trim();
    this.editFederationForm.patchValue({
      signInButtonText: item.value.signInButtonText,
    });

    if (
      this.editFederationForm.controls["signInButtonText"].hasError("blank")
    ) {
      item["signInButtonError"] = "Please enter the Sign In Button Text.";
      this.signInButtonBlank = true;
    } else {
      item["signInButtonError"] = "";
      this.signInButtonBlank = false;
    }
  }

  onLogoutUrlChange(item) {
    this.federationTouched = true;
    item.value.logoutUrl = item.value.logoutUrl.trim();
    this.editFederationForm.patchValue({
      logoutUrl: item.value.logoutUrl,
    });

    if (this.editFederationForm.controls["logoutUrl"].hasError("invalidUrl")) {
      item["logoutUrlError"] = "URL must start with http:// or https://.";
      this.logoutUrlHasError = true;
    } else if (
      this.editFederationForm.controls["logoutUrl"].hasError("hasSpaces")
    ) {
      item["logoutUrlError"] = "Spaces are not allowed.";
      this.logoutUrlHasError = true;
    } else {
      item["logoutUrlError"] = "";
      this.logoutUrlHasError = false;
    }
  }

  onSloEnabledChange(item, checked) {
    this.federationTouched = true;
    // Update the item value and form control
    item.value.sloEnabled = checked;
    // Update the form control value as well
    const formArray = this.federationDetailForm.get(
      "value",
    ) as UntypedFormArray;
    const index = formArray.controls.findIndex(
      (control) => control.value === item.value,
    );
    if (index >= 0) {
      formArray.at(index).get("sloEnabled").setValue(checked);
    }
  }

  urlValidator(control: AbstractControl) {
    const value = control.value;
    if (!value) {
      return null; // Optional field, so empty is valid
    }

    const trimmedValue = value.trim();

    // Check for spaces in the middle of the URL
    const emptySpacePattern = /\s/;
    if (emptySpacePattern.test(trimmedValue)) {
      return { hasSpaces: true };
    }

    // Check if URL starts with http:// or https://
    const lowerValue = trimmedValue.toLowerCase();
    if (
      !lowerValue.startsWith("http://") &&
      !lowerValue.startsWith("https://")
    ) {
      return { invalidUrl: true };
    }

    return null;
  }

  onProductsNeededChange(productsOption, isChecked) {
    switch (productsOption.toString()) {
      case "Skilled Nursing": {
        this.snfTouched = true;
        break;
      }
      case "Life Plan Community": {
        this.lpcTouched = true;
        break;
      }
      case "Payment Portal": {
        this.ppTouched = true;
        break;
      }
      case "Retail Tracker Online": {
        this.rtoTouched = true;
        break;
      }
      case "Senior Living": {
        this.slTouched = true;
        break;
      }
      case "CareAssist": {
        this.caTouched = true;
        if (isChecked) {
          this.isCaSelected = true;
        } else if (!isChecked) {
          this.isCaSelected = false;
          //If user unselects CareAssist, must unselect CA Optional parameters too
          var checkedProducts =
            this.configurationDetailForm.controls["productsNeeded"].value;
          let onScreenKeyboardIndex =
            this.productsOptions.indexOf("OnScreenKeyboard");
          checkedProducts[onScreenKeyboardIndex] = false;
          let pinIndex = this.productsOptions.indexOf("Pin");
          checkedProducts[pinIndex] = false;
          this.configurationDetailForm.controls["productsNeeded"].setValue(
            checkedProducts,
          );
        }
        break;
      }
      case "OnScreenKeyboard": {
        this.caOnScreenKeyBoardTouched = true;
        break;
      }
      case "Pin": {
        this.caPinTouched = true;
        break;
      }
      case "Meal Tracker": {
        this.mtTouched = true;
        break;
      }
      case "Matrixcare Marketing": {
        this.intmTouched = true;
        break;
      }
      case "Care Community": {
        this.ccTouched = true;
        break;
      }
      case "Matrixcare Connect": {
        this.ctTouched = true;
        break;
      }
      case "Home Care Private Duty": {
        this.pdTouched = true;
        break;
      }
      case "Home Health and Hospice (HHP)": {
        this.hhTouched = true;
        break;
      }
      case "Platform Configurations": {
        this.bpTouched = true;
        break;
      }
      case "Citus Health (CH)": {
        this.chTouched = true;
        break;
      }
      case "MatrixCare Engage": {
        this.myMatrixTouched = true;
        this.errorMessageMyMatrix = "";

        if (isChecked) {
          // Validate SNF URL and corpOID requirements
          if (
            this.snfAppUrl != null &&
            this.snfAppUrl != "" &&
            this.corpOid != null &&
            this.corpOid != "" &&
            this.snfApiUrl != null &&
            this.snfApiUrl != ""
          ) {
            // Success - MatrixCare Engage enabled, automatically enable MatrixCare 360 Seeding
            if (this.matrixCare360SeedingEnabledEnding !== "true") {
              this.matrixCare360SeedingEnabledEnding = "true";
              $("#cb_sharedComponentsMatrixCare360Seeding ").prop(
                "checked",
                true,
              );
              this.matrixCare360SeedingTouched = true;
            }
          } else {
            // SNF validation failed - uncheck the checkbox and show error
            this.errorMessageMyMatrix =
              "MatrixCare Engage requires SNF app/api URL and corpOID parameters. Unable to enable it at this time.";
            this.uncheckMatrixCareEngage();
          }
        } else {
          // If user unselects MatrixCare Engage, must unselect Contact/Family access to the Chat too
          this.uncheckMatrixCareEngageChildren();
        }
        break;
      }
      case "Contact/Family access to the Chat": {
        this.contactFamilyChatTouched = true;
        break;
      }
      case "MatrixCare eForms": {
        this.matrixCareEFormsTouched = true;
        this.errorMessageMatrixCareEForms = "";

        if (isChecked) {
          // Validate SNF URL and corpOID requirements
          if (
            this.snfAppUrl != null &&
            this.snfAppUrl != "" &&
            this.corpOid != null &&
            this.corpOid != "" &&
            this.snfApiUrl != null &&
            this.snfApiUrl != ""
          ) {
            // Success - MatrixCare eForms enabled, automatically enable MatrixCare 360 Seeding
            if (this.matrixCare360SeedingEnabledEnding !== "true") {
              this.matrixCare360SeedingEnabledEnding = "true";
              $("#cb_sharedComponentsMatrixCare360Seeding ").prop(
                "checked",
                true,
              );
              this.matrixCare360SeedingTouched = true;
            }
          } else {
            // SNF validation failed - uncheck the checkbox and show error
            this.errorMessageMatrixCareEForms =
              "MatrixCare eForms requires SNF app/api URL and corpOID parameters. Unable to enable it at this time.";
            this.uncheckMatrixCareEForms();
          }
        }
        break;
      }
      case "Solutions for Business": {
        this.solutionsForBusinessTouched = true;
        this.errorMessageSolutionsForBusiness = "";

        if (isChecked) {
          // Validate SNF URL and corpOID requirements
          if (
            this.snfAppUrl != null &&
            this.snfAppUrl != "" &&
            this.corpOid != null &&
            this.corpOid != "" &&
            this.snfApiUrl != null &&
            this.snfApiUrl != ""
          ) {
            // Auto-select MatrixCare 360 Seeding (dependency requirement)
            $("#cb_sharedComponentsMatrixCare360Seeding").prop("checked", true);
            this.matrixCare360SeedingChanged(true);
            this.validateSolutionsForBusinessModules();
          } else {
            // SNF validation failed - uncheck the checkbox and show error
            this.errorMessageSolutionsForBusiness =
              "Solutions for Business requires SNF app/api URL and corpOID parameters. Unable to enable it at this time.";
            this.uncheckSolutionsForBusiness();
          }
        } else {
          // If unchecking Solutions for Business, must uncheck module parameters too
          var checkedProducts =
            this.configurationDetailForm.controls["productsNeeded"].value;
          let efaIndex = this.productsOptions.indexOf(
            "Entrance Fee Amortization",
          );
          checkedProducts[efaIndex] = false;
          let pnsmIndex = this.productsOptions.indexOf(
            "Parking & Storage Management",
          );
          checkedProducts[pnsmIndex] = false;
          this.configurationDetailForm.controls["productsNeeded"].setValue(
            checkedProducts,
          );
          this.sbEfaTouched = true;
          this.sbPnsmTouched = true;
          this.errorMessageSolutionsForBusiness = "";
        }
        break;
      }
      case "Entrance Fee Amortization": {
        this.sbEfaTouched = true;
        this.validateSolutionsForBusinessModules();
        break;
      }
      case "Parking & Storage Management": {
        this.sbPnsmTouched = true;
        this.validateSolutionsForBusinessModules();
        break;
      }
      default: {
        break;
      }
    }
  }

  isSubOption(productName: string): boolean {
    return [
      "Pin",
      "OnScreenKeyboard",
      "Contact/Family access to the Chat",
      "Entrance Fee Amortization",
      "Parking & Storage Management",
    ].includes(productName);
  }

  getSubOptionDisabled(productName: string): boolean | null {
    if (productName === "Pin" || productName === "OnScreenKeyboard") {
      return this.editProfile && this.isCaSelected ? null : true;
    }
    if (productName === "Contact/Family access to the Chat") {
      return this.editProfile && this.isMatrixCareEngageSelected()
        ? null
        : true;
    }
    if (
      productName === "Entrance Fee Amortization" ||
      productName === "Parking & Storage Management"
    ) {
      return this.editProfile && this.isSolutionsForBusinessSelected()
        ? null
        : true;
    }
    return true;
  }

  hasSpecialHandling(productName: string): boolean {
    return (
      productName === "MatrixCare Engage" ||
      productName === "MatrixCare eForms" ||
      productName === "Solutions for Business"
    );
  }

  getTooltipText(productName: string): string {
    if (productName === "MatrixCare Engage") {
      return "• This will enable the <strong>MatrixCare Engage-related UI</strong> in both the <strong>User Management Tool</strong> and <strong>MatrixCare 360</strong><br>• Cannot be enabled unless <strong>MatrixCare 360 Seeding</strong> is SELECTED";
    }
    if (productName === "MatrixCare eForms") {
      return "• This will enable the <strong>MatrixCare eForms-related UI</strong> in both the <strong>User Management Tool</strong> and <strong>MatrixCare 360</strong><br>• Cannot be enabled unless <strong>MatrixCare 360 Seeding</strong> is SELECTED";
    }
    return "• This will enable <strong>Solutions for Business</strong> in the <strong>User Management Tool</strong><br>• Cannot be enabled unless <strong>MatrixCare 360 Seeding</strong> is SELECTED";
  }

  getErrorMessage(productName: string): string {
    if (productName === "MatrixCare Engage") {
      return this.errorMessageMyMatrix;
    }
    if (productName === "MatrixCare eForms") {
      return this.errorMessageMatrixCareEForms;
    }
    return this.errorMessageSolutionsForBusiness;
  }

  uncheckMatrixCareEngageChildren() {
    // Uncheck Contact/Family access to the Chat when MatrixCare Engage is unchecked
    const contactFamilyChatIndex = this.productsOptions.indexOf(
      "Contact/Family access to the Chat",
    );
    if (contactFamilyChatIndex !== -1) {
      this.configurationDetailForm.controls["productsNeeded"]["controls"][
        contactFamilyChatIndex
      ].setValue(false);
      this.contactFamilyChatTouched = true;
    }
  }

  uncheckMatrixCareEngage() {
    if (this.isMatrixCareEngageSelected()) {
      const matrixEngageIndex =
        this.productsOptions.indexOf("MatrixCare Engage");
      if (matrixEngageIndex !== -1) {
        this.configurationDetailForm.controls["productsNeeded"]["controls"][
          matrixEngageIndex
        ].setValue(false);
        this.myMatrixTouched = true;
      }
    }

    // Also uncheck child options
    this.uncheckMatrixCareEngageChildren();
  }

  uncheckMatrixCareEForms() {
    if (this.isMatrixCareEFormsSelected()) {
      const matrixEFormsIndex =
        this.productsOptions.indexOf("MatrixCare eForms");
      if (matrixEFormsIndex !== -1) {
        this.configurationDetailForm.controls["productsNeeded"]["controls"][
          matrixEFormsIndex
        ].setValue(false);
        this.matrixCareEFormsTouched = true;
      }
    }
  }

  uncheckSolutionsForBusiness() {
    if (this.isSolutionsForBusinessSelected()) {
      const solutionsForBusinessIndex = this.productsOptions.indexOf(
        "Solutions for Business",
      );
      if (solutionsForBusinessIndex !== -1) {
        this.configurationDetailForm.controls["productsNeeded"]["controls"][
          solutionsForBusinessIndex
        ].setValue(false);
        this.solutionsForBusinessTouched = true;
        // Also uncheck module parameters
        var checkedProducts =
          this.configurationDetailForm.controls["productsNeeded"].value;
        let efaIndex = this.productsOptions.indexOf(
          "Entrance Fee Amortization",
        );
        checkedProducts[efaIndex] = false;
        let pnsmIndex = this.productsOptions.indexOf(
          "Parking & Storage Management",
        );
        checkedProducts[pnsmIndex] = false;
        this.configurationDetailForm.controls["productsNeeded"].setValue(
          checkedProducts,
        );
        this.sbEfaTouched = true;
        this.sbPnsmTouched = true;
      }
    }
  }

  isMatrixCareEngageSelected() {
    const matrixEngageIndex = this.productsOptions.indexOf("MatrixCare Engage");
    if (
      matrixEngageIndex !== -1 &&
      this.configurationDetailForm.controls["productsNeeded"]["controls"][
        matrixEngageIndex
      ]
    ) {
      return this.configurationDetailForm.controls["productsNeeded"][
        "controls"
      ][matrixEngageIndex].value;
    }
    return false;
  }

  isMatrixCareEFormsSelected() {
    const matrixEFormsIndex = this.productsOptions.indexOf("MatrixCare eForms");
    if (
      matrixEFormsIndex !== -1 &&
      this.configurationDetailForm.controls["productsNeeded"]["controls"][
        matrixEFormsIndex
      ]
    ) {
      return this.configurationDetailForm.controls["productsNeeded"][
        "controls"
      ][matrixEFormsIndex].value;
    }
    return false;
  }

  isSolutionsForBusinessSelected() {
    const solutionsForBusinessIndex = this.productsOptions.indexOf(
      "Solutions for Business",
    );
    if (
      solutionsForBusinessIndex !== -1 &&
      this.configurationDetailForm.controls["productsNeeded"]["controls"][
        solutionsForBusinessIndex
      ]
    ) {
      return this.configurationDetailForm.controls["productsNeeded"][
        "controls"
      ][solutionsForBusinessIndex].value;
    }
    return false;
  }

  validateSolutionsForBusinessModules() {
    if (this.isSolutionsForBusinessSelected()) {
      const efaSelected =
        this.configurationDetailForm.get("productsNeeded").value[
          this.productsOptions.indexOf("Entrance Fee Amortization")
        ];
      const pnsmSelected =
        this.configurationDetailForm.get("productsNeeded").value[
          this.productsOptions.indexOf("Parking & Storage Management")
        ];
      if (!efaSelected && !pnsmSelected) {
        this.errorMessageSolutionsForBusiness =
          "At least one Solutions for Business module must be selected.";
      } else {
        this.errorMessageSolutionsForBusiness = "";
      }
    } else {
      this.errorMessageSolutionsForBusiness = "";
    }
  }

  sharedComponentsLauncherChanged(item) {
    //had to manually add this here as it was not working on HTML with  formControlName
    this.configurationDetailForm.markAsDirty();
    //need this block to set shared components to false when changing SSO
    this.configurationDetailForm
      .get("sharedComponentsLauncher")
      .setValue(item.toString());
    this.configuration.sharedComponentsLauncher = item.toString();

    if (item) {
      this.loadVendorOptions();
    }
  }

  sharedComponentsContextSharingChanged(item) {
    //had to manually add this here as it was not working on HTML with  formControlName
    this.configurationDetailForm.markAsDirty();
    //need this block to set shared components to false when changing SSO
    this.configurationDetailForm
      .get("sharedComponentsContextSharing")
      .setValue(item.toString());
    this.configuration.sharedComponentsContextSharing = item.toString();
  }

  globalSearchChanged(item) {
    this.errorMessageGlobalSearch = "";

    //Only allow check GS if snf app url and snf corpOID is present
    if (item.toString() == "true") {
      if (
        this.snfAppUrl != null &&
        this.snfAppUrl != "" &&
        this.corpOid != null &&
        this.corpOid != ""
      ) {
        this.globalSearchEnabledEnding = item.toString();
      } else {
        this.errorMessageGlobalSearch =
          "Search requires SNF URL and corpOID parameters. Unable to activate Search.";
        this.globalSearchEnabledEnding = "false";
        $("#cb_sharedComponentsGlobalSearch ").prop("checked", false);
      }
    } else {
      this.globalSearchEnabledEnding = "false";
      $("#cb_sharedComponentsGlobalSearch ").prop("checked", false);
    }
    this.globalSearchTouched = true;
  }

  matrixCare360SeedingChanged(item) {
    this.errorMessageMatrixCare360Seeding = "";

    //Only allow check MatrixCare 360 Seeding if snf app url and snf corpOID is present
    if (item.toString() == "true") {
      if (
        this.snfAppUrl != null &&
        this.snfAppUrl != "" &&
        this.corpOid != null &&
        this.corpOid != "" &&
        this.snfApiUrl != null &&
        this.snfApiUrl != ""
      ) {
        this.matrixCare360SeedingEnabledEnding = item.toString();
      } else {
        this.errorMessageMatrixCare360Seeding =
          "MatrixCare 360 Seeding requires SNF app/api URL and corpOID parameters. Unable to enable it at this time.";
        this.matrixCare360SeedingEnabledEnding = "false";
        $("#cb_sharedComponentsMatrixCare360Seeding ").prop("checked", false);
      }
    } else {
      // If disabling seeding, also disable MatrixCare Engage, MatrixCare eForms and Solutions for Business
      this.uncheckMatrixCareEngage();
      this.uncheckMatrixCareEForms();
      this.uncheckSolutionsForBusiness();
      this.matrixCare360SeedingEnabledEnding = "false";
      $("#cb_sharedComponentsMatrixCare360Seeding ").prop("checked", false);
    }
    this.matrixCare360SeedingTouched = true;
  }

  alineChanged(item) {
    //Enable Aline integration
    if (item.toString() == "true") {
      this.alineEnabledEnding = item.toString();
    } else {
      this.alineEnabledEnding = "false";
      $("#cb_ssoIntegrationsAline ").prop("checked", false);
    }
    this.alineTouched = true;
  }

  nurseRosieChanged(item) {
    //Enable Nurse Rosie integration
    if (item.toString() == "true") {
      this.nurseRosieEnabledEnding = item.toString();
    } else {
      this.nurseRosieEnabledEnding = "false";
      $("#cb_ssoIntegrationsNurseRosie ").prop("checked", false);
    }
    this.nurseRosieTouched = true;
  }

  trueSenseChanged(item) {
    if (item.toString() == "true") {
      this.trueSenseEnabledEnding = item.toString();
    } else {
      this.trueSenseEnabledEnding = "false";
      $("#cb_ssoIntegrationsTrueSense ").prop("checked", false);
    }
    this.trueSenseTouched = true;
  }

  sureCountChanged(item) {
    if (item.toString() == "true") {
      this.sureCountEnabledEnding = item.toString();
    } else {
      this.sureCountEnabledEnding = "false";
      $("#cb_ssoIntegrationsSureCount ").prop("checked", false);
    }
    this.sureCountTouched = true;
  }

  clearUserManagement() {
    this.userManagementChanged("clear");
    this.idpIdIsBlank = false;
    this.logoutUrlHasError = false;
  }

  getCustomer(customerId) {
    if (customerId) {
      this.customerService
        .getCustomer(customerId)
        .subscribe((customer) => (this.customerName = customer.accountName));
    }
  }

  async getCustomerConfigurationParameters() {
    if (!this.configurationId) return;

    const id = +this.route.snapshot.paramMap.get("id");
    if (this.configurationId) {
      this.customerConfigurationParameters = await this.configurationService
        .getCustomerConfigurationParameters(this.configurationId)
        .toPromise();
      this.isActive =
        this.customerConfigurationParameters.customerConfigurationDto.isActive;
    }
    if (this.customerConfigurationParameters.customer.id) {
      this.customerName =
        this.customerConfigurationParameters.customer.accountName;
    }

    //get federation parameter
    let oktaFederationParameter =
      this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "provision.usermanagement.okta.federation",
      );
    this.federationDetailForm
      .get("configurationId")
      .setValue(this.configurationId);
    //need this to created the three checkboxes for federated login is user management is okta
    if (
      this.customerConfigurationParameters.customerConfigurationDto
        .userManagementOkta
    ) {
      this.userManagementChanged("Okta");
    }
    this.isCaSelected = false;
    if (
      this.customerConfigurationParameters.customerConfigurationDto
        .productsNeeded &&
      this.customerConfigurationParameters.customerConfigurationDto.productsNeeded
        .toString()
        .includes("CareAssist")
    ) {
      this.isCaSelected = true;
    }

    //if an okta federation parameter gets returned, then it is not a new parameter.
    if (oktaFederationParameter.length > 0) {
      this.newOktaFederationParam = false;
      this.federationParamId = oktaFederationParameter[0].id;
      this.arrayJsonValue = JSON.parse(oktaFederationParameter[0].value);

      this.federationDetailForm.patchValue({
        id: this.federationParamId,
        configuration: this.configurationId,
        key: "provision.usermanagement.okta.federation",
        value: this.arrayJsonValue,
      });

      if (
        this.federationDetailForm
          .get("value")
          ["controls"][0]["controls"]["federationName"].value.toLowerCase()
          .includes("not federated")
      ) {
        this.notFederated = true;
      } else {
        this.notFederated = false;
      }
    } else if (
      oktaFederationParameter.length == 0 &&
      this.customerConfigurationParameters.customerConfigurationDto
        .userManagementOkta
    ) {
      this.newOktaFederationParam = true;
      this.federationDetailForm.get("value")["controls"][0]["controls"][
        "federationName"
      ].value = "Not Federated (default)";
      this.notFederated = true;
    }
    await this.refreshForm(
      this.customerConfigurationParameters.customerConfigurationDto,
    );

    //get Tels Parameter and load on screen
    this.telsUrlParameter =
      this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "thirdparty.tels.app.url.root",
      )[0];
    if (this.telsUrlParameter) {
      this.telsUrlForm.patchValue({
        id: this.telsUrlParameter.id,
        configuration: this.configurationId,
        key: this.telsUrlParameter.key,
        value: this.telsUrlParameter.value,
      });
    }

    var value = this.customerConfigurationParameters.parameters.filter(
      (x) => x.key === "provision.sharedcomponents.launcher.enabled",
    )[0].value;
    if (value == "true") {
      await this.loadVendorOptions();
    }

    //Retrieve if Global search enabled
    this.globalSearchParameter =
      this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "bp.globalsearch.enabled",
      )[0];
    if (
      this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "snf.api.url.root",
      )[0]
    ) {
      this.snfApiUrl = this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "snf.api.url.root",
      )[0].value;
    }
    if (
      this.globalSearchParameter &&
      this.globalSearchParameter.value.toLowerCase() != "false"
    ) {
      this.globalSearchEnabled = this.globalSearchParameter.value;
      $("#cb_sharedComponentsGlobalSearch ").prop(
        "checked",
        this.globalSearchEnabled.toLowerCase,
      );
    } else {
      $("#cb_sharedComponentsGlobalSearch ").prop("checked", false);
    }

    //Retrieve if MatrixCare 360 Seeding enabled
    this.matrixCare360SeedingParameter =
      this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "multicare.matrixcare360.seeding.enabled",
      )[0];
    if (this.matrixCare360SeedingParameter) {
      this.matrixCare360SeedingEnabled =
        this.matrixCare360SeedingParameter.value;
      $("#cb_sharedComponentsMatrixCare360Seeding ").prop(
        "checked",
        this.matrixCare360SeedingEnabled.toLowerCase,
      );
    } else {
      $("#cb_sharedComponentsMatrixCare360Seeding ").prop("checked", false);
    }

    //Retrieve if Aline enabled
    this.alineParameter =
      this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "ssointegrations.aline.enabled",
      )[0];
    if (this.alineParameter) {
      this.alineEnabled = this.alineParameter.value;
      $("#cb_ssoIntegrationsAline ").prop(
        "checked",
        this.alineEnabled.toLowerCase,
      );
    } else {
      $("#cb_ssoIntegrationsAline ").prop("checked", false);
    }

    //Retrieve if Nurse Rosie enabled
    this.nurseRosieParameter =
      this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "ssointegrations.nurserosie.enabled",
      )[0];
    if (this.nurseRosieParameter) {
      this.nurseRosieEnabled = this.nurseRosieParameter.value;
      $("#cb_ssoIntegrationsNurseRosie ").prop(
        "checked",
        this.nurseRosieEnabled.toLowerCase,
      );
    } else {
      $("#cb_ssoIntegrationsNurseRosie ").prop("checked", false);
    }

    //Retrieve if True Sense enabled
    this.trueSenseParameter =
      this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "ssointegrations.truesense.enabled",
      )[0];
    if (this.trueSenseParameter) {
      this.trueSenseEnabled = this.trueSenseParameter.value;
      $("#cb_ssoIntegrationsTrueSense ").prop(
        "checked",
        this.trueSenseEnabled.toLowerCase,
      );
    } else {
      $("#cb_ssoIntegrationsTrueSense ").prop("checked", false);
    }

    //Retrieve if SureCount enabled
    this.sureCountParameter =
      this.customerConfigurationParameters.parameters.filter(
        (x) => x.key === "ssointegrations.surecount.enabled",
      )[0];
    if (this.sureCountParameter) {
      this.sureCountEnabled = this.sureCountParameter.value;
      $("#cb_ssoIntegrationsSureCount ").prop(
        "checked",
        this.sureCountEnabled.toLowerCase,
      );
    } else {
      $("#cb_ssoIntegrationsSureCount ").prop("checked", false);
    }
  }

  addParameter(): void {
    this.loading = true;
    const parameter = new Parameter(this.parameterDetailForm.value);
    for (let p of this.customerConfigurationParameters.parameters) {
      var exists = this.customerConfigurationParameters.parameters.filter(
        (x) => x.key.trim() === parameter.key.trim(),
      );
      if (exists.length > 0) {
        this.errorMessage = "Key already exists and cannot be re-added.";
        this.addError = true;
        this.loading = false;
        break;
      }
    }
    if (!this.addError) {
      this.newParameter = true;
      let obs: Observable<Parameter>;

      parameter.configurationId = this.configurationId;
      parameter.createdBy = this.username;
      delete parameter.environmentKey;
      delete parameter.corpOid;
      delete parameter.id;
      obs = this.parameterService.addParameter(parameter);
      //this.resetFlags();

      obs.subscribe(
        async (parameter) => {
          // If parameter was added successfully, id must have some value.
          if (parameter.id) {
            await this.refreshOnAddParameterForm();
            //this.resetFlags();
            this.successAlert = {
              message: `Parameter ${parameter.key} has been updated successfully`,
              type: AlertType.SUCCESS,
            };

            this.clearAlerts();
          } else {
            (status) => {
              this.messageService.send({
                type: MessageType.ParameterCreated,
                data: parameter.key,
              });
            };
          }
        },
        (err) => {
          this.alert = getAlertMessage(err);
          this.loading = false;
        },
      );
      this.parameterDetailForm.markAsUntouched();
      this.parameterDetailForm.patchValue({
        key: "",
        value: "",
      });
    }
  }

  uncheckProductsBasedOnParameter(): void {
    //if (JSON.stringify(this.groupedParameters) !== JSON.stringify(this.groupedParametersOld)) {
    //only need to uncheck/check products needed api when old products needed and new products needed do not match
    if (
      JSON.stringify(
        this.customerConfigurationParameters.customerConfigurationDto
          .productsNeeded,
      ) !== JSON.stringify(Object.keys(this.groupedParameters))
    ) {
      this.parameterDetailForm.value.key = "provision.productsneeded";

      // Start with products from groupedParameters
      let productsNeededValue = Object.keys(this.groupedParameters).join(",");

      // Preserve special products that are excluded from groupedParameters but were previously enabled
      // These products have their own specific parameter keys (paymentportal.enabled, multicare.mobile.enabled, etc.)
      // and are excluded from groupByProductName, but should remain in productsNeeded if they were enabled
      const specialProducts = [
        "Payment Portal",
        "MatrixCare Engage",
        "Contact/Family access to the Chat",
        "MatrixCare eForms",
        "Solutions for Business",
        "Entrance Fee Amortization",
        "Parking & Storage Management",
        "Retail Tracker Online",
      ];

      const existingProductsNeeded =
        this.customerConfigurationParameters.customerConfigurationDto
          .productsNeeded;
      if (existingProductsNeeded) {
        for (const product of specialProducts) {
          if (
            existingProductsNeeded.includes(product) &&
            !productsNeededValue.includes(product)
          ) {
            productsNeededValue = productsNeededValue + "," + product;
          }
        }
      }

      this.parameterDetailForm.value.value = productsNeededValue;

      //need this block since Pin is not its own section, added for bug when we have pin params, it was not checking pin, this way we push pin in products needed
      this.checkUncheckCAOptional();

      this.parameterDetailForm.value.configurationId = this.configurationId;

      this.parameterService
        .getParameterByKey(
          String(this.configurationId),
          "provision.productsneeded",
        )
        .subscribe((parameterByKey) => {
          this.parameterId = parameterByKey[0].id;
          this.parameterDetailForm.value.id = parameterByKey[0].id;
          this.updateProvisionProductsParameter();
        });

      this.loading = false;
    }
  }

  async checkProductsBasedOnParameter() {
    if (
      JSON.stringify(this.groupedParameters) !==
      JSON.stringify(this.groupedParametersOld)
    ) {
      this.parameterDetailForm.value.key = "provision.productsneeded";

      // Start with products from groupedParameters
      let productsNeededValue = Object.keys(this.groupedParameters).join(",");

      // Preserve special products that are excluded from groupedParameters but were previously enabled
      // These products have their own specific parameter keys (paymentportal.enabled, multicare.mobile.enabled, etc.)
      // and are excluded from groupByProductName, but should remain in productsNeeded if they were enabled
      const specialProducts = [
        "Payment Portal",
        "MatrixCare Engage",
        "Contact/Family access to the Chat",
        "MatrixCare eForms",
        "Solutions for Business",
        "Entrance Fee Amortization",
        "Parking & Storage Management",
        "Retail Tracker Online",
      ];

      const existingProductsNeeded =
        this.customerConfigurationParameters?.customerConfigurationDto
          ?.productsNeeded;
      if (existingProductsNeeded) {
        for (const product of specialProducts) {
          if (
            existingProductsNeeded.includes(product) &&
            !productsNeededValue.includes(product)
          ) {
            productsNeededValue = productsNeededValue + "," + product;
          }
        }
      }

      this.parameterDetailForm.value.value = productsNeededValue;
      this.parameterDetailForm.value.configurationId = this.configurationId;

      //need this block so if manually adding pin or onscreenkeyboard will check under products needed
      this.checkUncheckCAOptional();

      this.parameterService
        .getParameterByKey(
          String(this.configurationId),
          "provision.productsneeded",
        )
        .subscribe((parameterByKey) => {
          this.parameterId = parameterByKey[0].id;
          this.parameterDetailForm.value.id = parameterByKey[0].id;
          this.updateProvisionProductsParameter();
        });

      this.loading = false;
    }
  }

  checkUncheckCAOptional() {
    if (this.groupedParameters["CareAssist"]) {
      for (let x of this.groupedParameters["CareAssist"]) {
        if (
          x.key.toLowerCase().includes("ca.feature.pin.") &&
          !this.parameterDetailForm.value.value.includes("Pin")
        ) {
          this.parameterDetailForm.value.value =
            this.parameterDetailForm.value.value + ",Pin";
        } else if (
          x.key.toLowerCase().includes("ca.feature.onscreenkeyboard.") &&
          !this.parameterDetailForm.value.value.includes("OnScreenKeyboard")
        ) {
          this.parameterDetailForm.value.value =
            this.parameterDetailForm.value.value + ",OnScreenKeyboard";
        }
      }
    }
  }

  updateProvisionProductsParameter(): void {
    const parameter = new Parameter(this.parameterDetailForm.value);
    let obs: Observable<Parameter>;
    if (this.parameterId) {
      parameter.modifiedBy = this.username;
      obs = this.parameterService.updateParameter(this.parameterId, parameter);
    } else {
      parameter.configurationId = +this.route.snapshot.params.configurationId;
      parameter.createdBy = this.username;
      delete parameter.environmentKey;
      delete parameter.corpOid;
      delete parameter.id;
      obs = this.parameterService.addParameter(parameter);
    }

    obs.subscribe(
      (configuration) => {
        // If customer was updated successfully, id must have some value.
        if (this.parameterId) {
          this.resetFlags();
          this.loading = false;
          this.successAlert = {
            message: `Selected parameters have been removed and Parameter: ${parameter.key} has been updated successfully`,
            type: AlertType.SUCCESS,
          };

          this.clearAlerts();
        } else {
          (status) => {
            this.messageService.send({
              type: MessageType.ParameterCreated,
              data: parameter.key,
            });
          };
        }
      },
      (err) => {
        this.alert = getAlertMessage(err);
      },
    );
  }

  updateBatchParameters(): void {
    this.loading = true;
    this.newParameter = false;
    let parameterObject = [];

    Object.keys(this.groupedParameters).forEach((groupName) => {
      var newParameterRow;
      var oldParameterRow;
      for (var i = 0; i < this.groupedParameters[groupName].length; i++) {
        newParameterRow = this.groupedParameters[groupName][i];
        oldParameterRow = this.groupedParametersOld[groupName].filter(
          (x) => x.id == newParameterRow.id,
        )[0];
        if (
          JSON.stringify(newParameterRow.key) ===
            JSON.stringify(oldParameterRow.key) &&
          JSON.stringify(newParameterRow.value) ===
            JSON.stringify(oldParameterRow.value)
        ) {
        } else {
          let obj = {
            configurationId: this.configurationId,
            id: this.groupedParameters[groupName][i].id,
            key: this.groupedParameters[groupName][i].key,
            value: this.groupedParameters[groupName][i].value,
            modifiedBy: this.username,
          };
          parameterObject.push(obj);
        }
      }
    });

    if (parameterObject.length > 0) {
      let obs: Observable<Parameter>;
      obs = this.parameterService.updateBatchParameter(
        this.configurationId,
        parameterObject,
      );
      obs.subscribe(
        (configuration) => {
          // If customer was updated successfully, id must have some value.
          if (this.configurationId) {
            this.resetParameterFlags();
            this.successAlert = {
              message: `Configuration ${this.configurationId} has been updated successfully`,
              type: AlertType.SUCCESS,
            };
            this.clearAlerts();
            this.loading = false;
          } else {
            (status) => {
              this.messageService.send({
                type: MessageType.ParameterCreated,
                data: this.configurationId,
              });
            };
          }
        },
        (err) => {
          this.alert = getAlertMessage(err);
          this.cancelParameters();
        },
      );
    }
    this.editParameters = false;
  }

  public checkDefaultText() {
    this.errorMessage = "";
    this.addError = false;
    if (
      this.parameterDetailForm
        .get("key")
        .value.includes("bp.globalsearch.displayformat")
    ) {
      this.gsEnabled = true;
      return 'First Name \"Preferred Name\" Last Name';
    } else {
      this.gsEnabled = false;
      return "False";
    }
  }

  public checkDefaultTextMultiEdit(key) {
    if (key.includes("bp.globalsearch.displayformat")) {
      return 'First Name \"Preferred Name\" Last Name';
    } else {
      return "False";
    }
  }

  public checkSelect() {
    if (
      this.parameterDetailForm
        .get("key")
        .value.includes("bp.globalsearch.displayformat")
    ) {
      this.gsEnabled = true;
      return true;
    } else if (
      this.parameterDetailForm.get("key").value.includes("enabled") ||
      this.parameterDetailForm.get("key").value.includes("isdefault")
    ) {
      return true;
    } else {
      this.gsEnabled = false;
      return false;
    }
  }

  public checkSelectMultiEdit(key) {
    this.gsEnabled = false;
    if (key.includes("bp.globalsearch.displayformat")) {
      this.gsEnabled = true;
      return true;
    } else if (key.includes("enabled") || key.includes("isdefault")) {
      return true;
    } else {
      this.gsEnabled = false;
      return false;
    }
  }

  private async loadOptions() {
    await this.parameterService
      .getEnableDisableOptions()
      .pipe(
        map((data) => {
          this.enabledDisableData = data;
        }),
      )
      .toPromise();
    await this.parameterService
      .getGSDisplayOptions()
      .pipe(
        map((data) => {
          this.gsEnabledData = data;
        }),
      )
      .toPromise();
  }

  async refreshParameterListForm() {
    await this.parameterService
      .getParametersByConfigId(this.configurationId)
      .subscribe((data) => {
        this.groupedParameters = this.groupByProductName(
          data.filter((x) => x.configurationId === this.configurationId),
        );

        this.callHealthchecks();
        this.uncheckProductsBasedOnParameter();
      });
    var products = await this.parameterService.getProductNames().toPromise();
    products.forEach((x) => {
      this.productNames[x.key] = x.name;
    });
    if (
      this.groupedParameters["Skilled Nursing"].filter(
        (x) => x.key === "snf.api.url.root",
      )[0]
    ) {
      this.snfApiUrl = this.groupedParameters["Skilled Nursing"].filter(
        (x) => x.key === "snf.api.url.root",
      )[0].value;
    }
  }

  async refreshOnAddParameterForm() {
    let data = await this.parameterService
      .getParametersByConfigId(this.configurationId)
      .toPromise();
    this.groupedParameters = this.groupByProductName(
      data.filter((x) => x.configurationId === this.configurationId),
    );
    await this.checkProductsBasedOnParameter();
    this.getCustomerConfigurationParameters();
    this.callHealthchecks();
    var products = await this.parameterService.getProductNames().toPromise();
    products.forEach((x) => {
      this.productNames[x.key] = x.name;
    });
  }

  checkAllCheckBox(ev, productGroupSelected) {
    this.somethingIsChecked = false;
    //this handles each individual grouping
    this.groupedParameters[productGroupSelected].forEach(
      (x) => (x.checked = ev.target.checked),
    );
    //this handles enabling/disabling delete button based on if anything is selected in ANY grouping
    Object.keys(this.groupedParameters).forEach((groupName) => {
      this.groupedParameters[groupName].forEach((u) => {
        if (u.checked) {
          this.somethingIsChecked = true;
        }
      });
    });
  }

  uncheckAllCheckBox() {
    Object.keys(this.groupedParameters).forEach((groupName) => {
      this.groupedParameters[groupName].forEach((x) => (x.checked = false));
      this.somethingIsChecked = false;
    });
  }

  onCheck() {
    this.somethingIsChecked = false;
    Object.keys(this.groupedParameters).forEach((groupName) => {
      this.groupedParameters[groupName].forEach((u) => {
        if (u.checked) {
          this.somethingIsChecked = true;
        }
        //this unselects the select all for that product grouping if one of the keys under that grouping is not checked
        (
          document.getElementById(
            "cb_slselectall_" + groupName,
          ) as HTMLInputElement
        ).checked = false;
      });
    });
  }

  deleteBatchParameters() {
    this.deleteParameterIds = [];
    Object.keys(this.groupedParameters).forEach((groupName) => {
      this.groupedParameters[groupName].forEach((x) => {
        if (x.checked) {
          this.deleteParameterIds.push(x.id);
        }
      });
    });
    if (this.deleteParameterIds.length > 0) {
      this.showBulkParameterDeleteConfirmationWindow(
        this.deleteParameterIds.length,
      );
    }
    this.editParameters = false;
    this.somethingIsChecked = false;
    this.corpOid = "";
    this.snfAppUrl = "";
  }

  //the abstract control triggers validation thats why we are passing in
  onKeyChange(u: Parameter, keycontrol: NgModel) {
    if (u) {
      var valueName = keycontrol.name.replace("Key", "Value");
      var valueControl: AbstractControl =
        keycontrol.control.parent.controls[valueName];
      valueControl.updateValueAndValidity();
      //console.log("keycontrol",keycontrol.control.parent)
    }
  }

  onChange(value: string, event: KeyboardEvent, key: string) {
    //this ensures that the two properties are updated BEFORE the validator is called as we need them for valdiation
    if (key.toLowerCase().includes("snf.corpoid")) {
      var corpOid = Number((value || "") + event.key);
      this.corpOid = corpOid;
      //console.log("value in on change",value, event.key,corpOid,key);
    }

    if (key.includes("snf.app.url.root")) {
      var snfAppUrl = (value || "") + event.key;
      this.snfAppUrl = snfAppUrl;
    }
  }

  loadVendorOptions() {
    this.parameterService
      .getParametersByPartialKey(
        String(this.configurationId),
        "thirdpartyintegration.",
        false,
      )
      .subscribe(
        (parameterByPartialKey) => {
          this.vendorOptionsApi = this.groupByThirdPartyPrefix(
            parameterByPartialKey,
          );
          this.parameterService.addDefaultOption(this.vendorOptions);
        },
        (error) => {
          this.alert = getAlertMessage(error);
        },
      );

    //if new config it would stop here
    /*    if(!this.newConfig){
      this.vendorOptionsApi = this.groupByThirdPartyPrefix(this.customerConfigurationParameters.parameters);
    }*/

    //this call loads vendor options list from stack
    this.parameterService.getThirdPartyVendorParametersList().subscribe(
      (parameters) => {
        this.thirdPartyVendorOptions = parameters;
        this.parameterService.addDefaultOption(this.thirdPartyVendorOptions);
      },
      (error) => {
        this.alert = getAlertMessage(error);
      },
    );
  }

  vendorChanged(optionvalue) {
    if (optionvalue != "" && optionvalue != "Add New Vendor") {
      this.newThirdPartyVendor = false;
      this.thirdPartyIntegrationForm.patchValue({
        vendorOption: optionvalue,
        vendorType: "existing",
        integrationName: optionvalue
          .substring(0, optionvalue.indexOf("("))
          .trim()
          .replace(/\s/g, "")
          .toLowerCase(),
        iconName: optionvalue.substring(0, optionvalue.indexOf("(")).trim(),
        url: optionvalue.substring(
          optionvalue.indexOf("(") + 1,
          optionvalue.lastIndexOf(")"),
        ),
      });
    } else {
      this.newThirdPartyVendor = true;
    }
    this.displayVendorButtons = true;
  }

  addStackParameter(parameter): void {
    this.newParameter = true;
    this.loading = true;
    let obs: Observable<Parameter>;

    parameter.createdBy = this.username;
    obs = this.parameterService.addParameter(parameter);

    obs.subscribe(
      async (parameter) => {
        // If parameter was added successfully, id must have some value.
        if (parameter.id) {
          this.loadVendorOptions();
          this.successAlert = {
            message: `Stack Parameter ${parameter.key} has been added successfully`,
            type: AlertType.SUCCESS,
          };

          this.clearAlerts();
        } else {
          (status) => {
            this.messageService.send({
              type: MessageType.ParameterCreated,
              data: parameter.key,
            });
          };
        }
      },
      (err) => {
        this.alert = getAlertMessage(err);
      },
    );
  }

  public async addVendorParameterApi(thirdPartyVendor) {
    try {
      await this.parameterService
        .addThirdPartyParameters(thirdPartyVendor)
        .toPromise();
      this.resetVendorFlags();
    } catch (e) {
      this.alert = getAlertMessage(e);
    }
  }

  addThirdPartyVendorButton() {
    this.loading = true;
    this.thirdPartyIntegrationForm.removeControl("key");
    const thirdPartyIntegrationVendor = new ThirdPartyIntegration(
      this.thirdPartyIntegrationForm.value,
    );
    thirdPartyIntegrationVendor.configurationId = this.configurationId;
    thirdPartyIntegrationVendor.createdBy = this.username;

    if (this.commonSharedVendor) {
      //making 2 calls, one to create to stack and other to config
      this.stackService.getCurrentStack().subscribe((stack) => {
        this.stackId = stack.id;
      });
      thirdPartyIntegrationVendor.stackId = this.stackId;
      this.addVendorParameterApi(thirdPartyIntegrationVendor);
    } else {
      //making only one add param call to config
      this.addVendorParameterApi(thirdPartyIntegrationVendor);
    }
    this.loading = false;
  }

  resetVendorFlags() {
    this.loading = true;
    this.loadVendorOptions();

    this.thirdPartyIntegrationForm.patchValue({
      vendorOption: "",
      integrationName: "",
      vendorType: "",
      iconName: "",
      key: "app.url",
      url: "",
    });

    this.thirdPartyIntegrationForm.markAsUntouched();
    this.displayVendorButtons = false;
    this.newThirdPartyVendor = false;
    this.loading = false;
  }

  vendorTypeChanged(type) {
    if (type == "Shared") {
      this.commonSharedVendor = true;
      this.uniqueVendor = false;
    } else {
      this.uniqueVendor = true;
      this.commonSharedVendor = false;
    }
    this.thirdPartyIntegrationForm.get("vendorType").setValue(type);
  }

  onIconNameChange(iconName: string) {
    this.thirdPartyIntegrationForm.patchValue({
      integrationName: iconName.replace(/\s/g, "").toLowerCase(),
    });
  }

  deleteThirdPartyParameter(displaynameid, urlid) {
    try {
      this.showThirdPartyDeleteConfirmationWindow(displaynameid, urlid);
    } catch (e) {
      this.alert = getAlertMessage(e);
    }
  }

  async showThirdPartyDeleteConfirmationWindow(displyanameid, urlid) {
    this.confirmationWindowRef = this.modalServiceDeleteSingleParameter.open(
      ParameterSingleDeleteConfirmationDialogComponent,
    );
    const comp = <ParameterSingleDeleteConfirmationDialogComponent>(
      this.confirmationWindowRef.componentInstance
    );
    const result: any = await this.confirmationWindowRef.result;

    if (result) {
      this.parameterService
        .deleteBatchParameter(displyanameid + "," + urlid)
        .subscribe(
          (res) => {
            this.resetVendorFlags();
          },
          (error) => {
            this.alert = getAlertMessage(error);
          },
        );
    }
  }

  editThirdPartyParameter(event, index, vendor) {
    this.enableEdit = true;
    this.enableEditIndex = index;
    this.displayNameInitial = vendor.displaynamevalue;
    this.urlInitial = vendor.urlvalue;
  }

  async updateThirdPartyVendor(vendor) {
    this.enableEdit = false;
    this.enableEditIndex = -1;
    let parameterObject = [];

    if (this.displayNameInitial != vendor.displaynamevalue) {
      let obj = {
        configurationId: this.configurationId,
        id: vendor.displaynameid,
        key: vendor.integrationprefix + ".displayname",
        value: vendor.displaynamevalue,
        modifiedBy: this.username,
      };
      parameterObject.push(obj);
    }
    if (this.urlInitial != vendor.urlvalue) {
      let obj = {
        configurationId: this.configurationId,
        id: vendor.urlid,
        key: vendor.integrationprefix + ".url",
        value: vendor.urlvalue,
        modifiedBy: this.username,
      };
      parameterObject.push(obj);
    }

    if (parameterObject.length > 0) {
      let result = await this.parameterService
        .updateBatchParameter(this.configurationId, parameterObject)
        .toPromise();
      if (result) {
        this.resetVendorFlags();
      }
    }
  }

  cancelThirdPartyParameter() {
    this.enableEdit = false;
    this.resetVendorFlags();
    this.enableEditIndex = -1;
  }

  async refreshClicked() {
    this.caHotReloading = true;
    setTimeout(() => (this.caHotReloading = false), 2000);
    const parameter = new Parameter();
    let obs: Observable<Parameter>;
    parameter.modifiedBy = this.username;
    parameter.configurationId = this.configurationId;
    parameter.createdBy = this.username;
    parameter.key = "ca.hotreload";
    parameter.value = "true";

    obs = this.parameterService.hotReload(parameter);
    let result = await obs.toPromise();
    setTimeout(() => {
      this.successAlert = {
        message: `Hot Reload to CareAssist has been called.`,
        type: AlertType.SUCCESS,
      };
    }, 1500);
  }

  async deleteLauncherContext() {
    this.deleteLauncherLoading = true;
    setTimeout(() => (this.deleteLauncherLoading = false), 2000);
    try {
      await this.parameterService
        .deleteLauncherContext(String(this.configurationId))
        .toPromise();
    } catch (e) {
      this.alert = getAlertMessage(e);
    }
  }

  async syncCisData() {
    this.CISSyncLoading = true;
    try {
      await this.modalService2.create<InformationDialogComponent>(
        InformationDialogComponent,
      ).modalRef.result;
      await this.parameterService
        .syncCisData(String(this.configurationId), String(this.username))
        .toPromise();
    } catch (e) {
      this.alert = getAlertMessage(e);
    } finally {
      setTimeout(() => (this.CISSyncLoading = false), 2000);
    }
  }

  async configurationGuidSync() {
    this.guidSyncLoading = true;
    this.loading = true;
    try {
      await this.configurationService
        .configurationGuidSync(String(this.configurationId))
        .toPromise();
      this.successAlert = {
        message: `GUID Sync has been completed successfully for configuration ID: ${this.configurationId}`,
        type: AlertType.SUCCESS,
      };
      this.resetFlags();
      this.guidSyncLoading = false;
    } catch (e) {
      this.alert = getAlertMessage(e);
      this.loading = false;
      this.guidSyncLoading = false;
    }
  }

  public async addUpdateDeleteBatchParametersEnabled(configurationId) {
    const gsParameter = new Parameter();
    const matrixCare360SeedingParameter = new Parameter();
    const alineParameter = new Parameter();
    const nurseRosieParameter = new Parameter();
    const trueSenseParameter = new Parameter();
    const sureCountParameter = new Parameter();
    let obs: Observable<Parameter>;

    let addParameterObject: Parameter[] = [];
    let updateParameterObject: Parameter[] = [];

    //ADD - if new parameters need to be added
    if (
      !this.globalSearchParameter &&
      this.globalSearchTouched &&
      this.globalSearchEnabledEnding == "true"
    ) {
      gsParameter.configurationId = configurationId;
      gsParameter.createdBy = this.username;
      gsParameter.key = "bp.globalsearch.enabled";
      gsParameter.value = "True";
      addParameterObject.push(gsParameter);
    }
    if (
      !this.matrixCare360SeedingParameter &&
      this.matrixCare360SeedingTouched &&
      this.matrixCare360SeedingEnabledEnding == "true"
    ) {
      matrixCare360SeedingParameter.configurationId = configurationId;
      matrixCare360SeedingParameter.createdBy = this.username;
      matrixCare360SeedingParameter.key =
        "multicare.matrixcare360.seeding.enabled";
      matrixCare360SeedingParameter.value = "True";
    }
    if (
      !this.alineParameter &&
      this.alineTouched &&
      this.alineEnabledEnding == "true"
    ) {
      alineParameter.configurationId = configurationId;
      alineParameter.createdBy = this.username;
      alineParameter.key = "ssointegrations.aline.enabled";
      alineParameter.value = "True";
      addParameterObject.push(alineParameter);
    }
    if (
      !this.nurseRosieParameter &&
      this.nurseRosieTouched &&
      this.nurseRosieEnabledEnding == "true"
    ) {
      nurseRosieParameter.configurationId = configurationId;
      nurseRosieParameter.createdBy = this.username;
      nurseRosieParameter.key = "ssointegrations.nurserosie.enabled";
      nurseRosieParameter.value = "True";
      addParameterObject.push(nurseRosieParameter);
    }
    if (
      !this.trueSenseParameter &&
      this.trueSenseTouched &&
      this.trueSenseEnabledEnding == "true"
    ) {
      trueSenseParameter.configurationId = configurationId;
      trueSenseParameter.createdBy = this.username;
      trueSenseParameter.key = "ssointegrations.truesense.enabled";
      trueSenseParameter.value = "True";
      addParameterObject.push(trueSenseParameter);
    }
    if (
      !this.sureCountParameter &&
      this.sureCountTouched &&
      this.sureCountEnabledEnding == "true"
    ) {
      sureCountParameter.configurationId = configurationId;
      sureCountParameter.createdBy = this.username;
      sureCountParameter.key = "ssointegrations.surecount.enabled";
      sureCountParameter.value = "True";
      addParameterObject.push(sureCountParameter);
    }

    if (addParameterObject.length > 0) {
      obs = this.parameterService.addBatchParameter(addParameterObject);
      let addBatchParameters = await obs.toPromise();
      // If parameter was added successfully, id must have some value.
      if (addBatchParameters) {
        this.successAlert = {
          message: `Parameters have been created successfully.`,
          type: AlertType.SUCCESS,
        };
        this.clearAlerts();
      }
    }

    if (matrixCare360SeedingParameter.configurationId) {
      this.matrixCare360SeedingLoading = true;
      this.myMatrixMessage = await this.parameterService
        .addMyMatrixParameter(matrixCare360SeedingParameter)
        .toPromise();

      // If parameter was added successfully, message should be empty or undefined
      if (this.myMatrixMessage !== undefined && !this.myMatrixMessage) {
        this.successAlert = {
          message: `MatrixCare 360 Seeding has been enabled successfully.`,
          type: AlertType.SUCCESS,
        };
        this.clearAlerts();
      } else {
        // Error occurred - show dialog and uncheck MatrixCare 360 Seeding
        this.showMyMatrixConfirmationDialog(this.myMatrixMessage);
        this.matrixCare360SeedingEnabledEnding = "false";
        $("#cb_sharedComponentsMatrixCare360Seeding ").prop("checked", false);

        // Uncheck MatrixCare Engage, MatrixCare eForms and Solutions for Business if they are enabled
        this.uncheckMatrixCareEngage();
        this.uncheckMatrixCareEForms();
        this.uncheckSolutionsForBusiness();

        this.messageService.send({
          type: AlertType.DANGER,
          message: "MatrixCare 360 Seeding could not be enabled at this time.",
        });
      }
      this.matrixCare360SeedingLoading = false;
    }

    //UPDATE - if not new param then update it (this was added because of pre-existing GS parameters but usually youll never have it but keeping it in case)
    if (
      this.globalSearchParameter &&
      this.globalSearchTouched &&
      this.globalSearchParameter.value.toLowerCase() == "false" &&
      this.globalSearchEnabledEnding == "true"
    ) {
      gsParameter.id = this.globalSearchParameter.id;
      gsParameter.modifiedBy = this.username;
      gsParameter.configurationId = this.configurationId;
      gsParameter.createdBy = this.username;
      gsParameter.key = "bp.globalsearch.enabled";
      gsParameter.value = "True";
      updateParameterObject.push(gsParameter);
    }
    if (
      this.alineParameter &&
      this.alineTouched &&
      this.alineParameter.value.toLowerCase() == "false" &&
      this.alineEnabledEnding == "true"
    ) {
      alineParameter.id = this.alineParameter.id;
      alineParameter.modifiedBy = this.username;
      alineParameter.configurationId = this.configurationId;
      alineParameter.createdBy = this.username;
      alineParameter.key = "ssointegrations.aline.enabled";
      alineParameter.value = "True";
      updateParameterObject.push(alineParameter);
    }
    if (
      this.nurseRosieParameter &&
      this.nurseRosieTouched &&
      this.nurseRosieParameter.value.toLowerCase() == "false" &&
      this.nurseRosieEnabledEnding == "true"
    ) {
      nurseRosieParameter.id = this.nurseRosieParameter.id;
      nurseRosieParameter.modifiedBy = this.username;
      nurseRosieParameter.configurationId = this.configurationId;
      nurseRosieParameter.createdBy = this.username;
      nurseRosieParameter.key = "ssointegrations.nurserosie.enabled";
      nurseRosieParameter.value = "True";
      updateParameterObject.push(nurseRosieParameter);
    }
    if (
      this.trueSenseParameter &&
      this.trueSenseTouched &&
      this.trueSenseParameter.value.toLowerCase() == "false" &&
      this.trueSenseEnabledEnding == "true"
    ) {
      trueSenseParameter.id = this.trueSenseParameter.id;
      trueSenseParameter.modifiedBy = this.username;
      trueSenseParameter.configurationId = this.configurationId;
      trueSenseParameter.createdBy = this.username;
      trueSenseParameter.key = "ssointegrations.truesense.enabled";
      trueSenseParameter.value = "True";
      updateParameterObject.push(trueSenseParameter);
    }
    if (
      this.sureCountParameter &&
      this.sureCountTouched &&
      this.sureCountParameter.value.toLowerCase() == "false" &&
      this.sureCountEnabledEnding == "true"
    ) {
      sureCountParameter.id = this.sureCountParameter.id;
      sureCountParameter.modifiedBy = this.username;
      sureCountParameter.configurationId = this.configurationId;
      sureCountParameter.createdBy = this.username;
      sureCountParameter.key = "ssointegrations.surecount.enabled";
      sureCountParameter.value = "True";
      updateParameterObject.push(sureCountParameter);
    }
    if (
      this.matrixCare360SeedingParameter &&
      this.matrixCare360SeedingTouched &&
      this.matrixCare360SeedingParameter.value.toLowerCase() == "false" &&
      this.matrixCare360SeedingEnabledEnding == "true"
    ) {
      matrixCare360SeedingParameter.id = this.matrixCare360SeedingParameter.id;
      matrixCare360SeedingParameter.modifiedBy = this.username;
      matrixCare360SeedingParameter.configurationId = this.configurationId;
      matrixCare360SeedingParameter.createdBy = this.username;
      matrixCare360SeedingParameter.key =
        "multicare.matrixcare360.seeding.enabled";
      matrixCare360SeedingParameter.value = "True";
      updateParameterObject.push(matrixCare360SeedingParameter);
    }

    if (updateParameterObject.length > 0) {
      obs = this.parameterService.updateBatchParameter(
        this.configurationId,
        updateParameterObject,
      );
      let updateGsMulticareMobileEnabledParameter = await obs.toPromise();

      // If customer was updated successfully, id must have some value.
      if (updateGsMulticareMobileEnabledParameter) {
        this.successAlert = {
          message: `Parameter has been updated successfully.`,
          type: AlertType.SUCCESS,
        };
      }
      this.clearAlerts();
    }

    //DELETE - if parameter exists and gets unselected then remove parameters
    if (
      this.matrixCare360SeedingParameter &&
      this.matrixCare360SeedingEnabledEnding == "false" &&
      this.matrixCare360SeedingTouched
    ) {
      this.deleteParameterIds.push(this.matrixCare360SeedingParameter.id);
    }
    if (
      this.globalSearchParameter &&
      this.globalSearchEnabledEnding == "false" &&
      this.globalSearchTouched
    ) {
      this.deleteParameterIds.push(this.globalSearchParameter.id);
    }
    if (
      this.alineParameter &&
      this.alineEnabledEnding == "false" &&
      this.alineTouched
    ) {
      this.deleteParameterIds.push(this.alineParameter.id);
    }
    if (
      this.nurseRosieParameter &&
      this.nurseRosieEnabledEnding == "false" &&
      this.nurseRosieTouched
    ) {
      this.deleteParameterIds.push(this.nurseRosieParameter.id);
    }
    if (
      this.trueSenseParameter &&
      this.trueSenseEnabledEnding == "false" &&
      this.trueSenseTouched
    ) {
      this.deleteParameterIds.push(this.trueSenseParameter.id);
    }
    if (
      this.sureCountParameter &&
      this.sureCountEnabledEnding == "false" &&
      this.sureCountTouched
    ) {
      this.deleteParameterIds.push(this.sureCountParameter.id);
    }
    if (this.deleteParameterIds.length > 0) {
      try {
        await this.parameterService
          .deleteBatchParameter(this.deleteParameterIds.toString())
          .toPromise();
      } catch (e) {
        this.alert = getAlertMessage(e);
      }
    }
  }

  async showMyMatrixConfirmationDialog(message) {
    var modal = this.modalService.create<MymatrixConfirmationDialogComponent>(
      MymatrixConfirmationDialogComponent,
    );
    let message2: { message: string } = {
      message: message,
    };
    modal.component.message = message2;
    var result = await modal.modalRef.result;
  }

  async resetElasticDb() {
    this.globalSearchResetLoading = true;
    this.snfApiUrl = this.customerConfigurationParameters.parameters.filter(
      (x) => x.key === "snf.api.url.root",
    )[0].value;
    if (this.snfApiUrl) {
      try {
        await this.parameterService
          .resetElasticDb(this.snfApiUrl, String(this.configurationId))
          .toPromise();
        this.successAlert = {
          message: `Elastic Database has been successfully reset.`,
          type: AlertType.SUCCESS,
        };
      } catch (e) {
        this.alert = getAlertMessage(e);
      }
      this.globalSearchResetLoading = false;
    }
  }
}
